export const WF_PROCESS_EDITOR_LANG_RESOURCES = {
  "zh-CHS": {
    "validate": {
      "noProcessHeader": "模型不存在processHeader属性",
      "cmpsEmpty": "流程构件为空",
      "cmpsEmptyMsg": "流程构件不允许为空，请联系表单开发确认问题",
      "directNoPf": "启动方式为【直接】的流程不应该包含共享（PF）的流程构件",
      "directNoPfMsg": "请移除以下共享（PF）的流程构件：",
      "noLoadDataCmp": "缺少执行时机为[获取数据]的流程构件",
      "noLoadDataCmpMsg": "流程定义不能缺少取数构件，请联系表单开发确认问题",
      "noStartCmp": "缺少执行时机为[流程启动]的流程构件",
      "noStartCmpMsg": "会导致流程启动时无法修改单据状态，请联系表单开发确认问题",
      "lackProcessCompleteCmp": "缺少执行时机为[流程完成]的流程构件",
      "lackProcessCompleteCmpMsg": "会导致流程完成时无法修改单据状态，请联系表单开发确认问题",
      "lackProcessAbortCmp": "缺少执行时机为[流程终止]的流程构件",
      "lackProcessAbortCmpMsg": "会导致流程终止时无法修改单据状态，请联系表单开发确认问题",
      "lackProcessCancelCmp": "缺少执行时机为[流程终止]的流程构件",
      "lackProcessCancelCmpMsg": "会导致流程终止时无法修改单据状态，请联系表单开发确认问题",
      "lackProcessBackCmp": "缺少执行时机为[流程驳回]的流程构件",
      "lackProcessBackCmpMsg": "会导致流程驳回时无法修改单据状态，请联系表单开发确认问题",
      "lackProcessReStartCmp": "缺少执行时机为[重新提交]的流程构件",
      "lackProcessReStartCmpMsg": "会导致流程重新提交时无法修改单据状态，请联系表单开发确认问题",
      "parallelGatewayCheck": "【并行网关】没有成对出现",
      "parallelGatewayCheckMsg": "【并行网关】需作为一条流程分支的拆分节点和汇聚节点成对出现，请修改",
      "inclusiveGatewayCheck": "【包容网关】没有成对出现",
      "inclusiveGatewayCheckMsg": "【包容网关】需作为一条流程分支的拆分节点和汇聚节点成对出现，请修改",
      "approvalPerformerCheck": "活动，未设置参与者",
      "notifyPerformerCheck": "节点，未设置知会接收人",
      "noVariable1": "活动【变量设置】属性中已设置变量",
      "noVariable2": "在流程属性【流程变量】中已不存在，请修改！",
      "noSignRule": "节点未设置会签规则",
      "activity": "活动【",
      "noStartActivity": "】的标识不合法，不是以[startActivity]开头",
      "noExclusiveGateway": "】的标识不合法，不是以[ExclusiveGateway]开头",
      "noParallelGateway": "】的标识不合法，不是以[ParallelGateway]开头",
      "noUserActivity": "】的标识不合法，不是以[UserActivity]开头",
      "noOperationActivity": "】的标识不合法，不是以[OperationActivity]开头",
      "noNotifyActivity": "】的标识不合法，不是以[NotifyActivity]开头",
      "noCallActivitySubProcess": "】的标识不合法，不是以[CallActivitySubProcess]开头",
      "noAutoActivity": "】的标识不合法，不是以[AutoActivity]开头",
      "noIntermediateCatchEvent": "】的标识不合法，不是以[IntermediateCatchEventImpl]开头",
      "noMessageActivity": "】的标识不合法，不是以[MessageActivity]开头",
      "noAifCreationBillActivity": "】的标识不合法，不是以[AifCreationBillActivity]开头",
      "noEndEvent": "】的标识不合法，不是以[EndEvent]开头",
      "mark": "标识为【",
      "noFlowNodeChsName": "】的活动简体中文名称为空，请修改",
      "nameExceedsLengthLimit": "】的名称超长，不能超过40个字符，请修改"
    },
    "processEditor": {
      "tip": "提示",
      "showButton": "显示查看模型按钮",
      "changeRecord": "流程变更记录",
      "noDtInfo": "不存在设计时流程信息！请先赋值！",
      "noRtInfo": "不存在运行时流程信息！请先赋值！",
      "wrongMoment": "设计器运行时机错误！",
      "prompted": "系统提示",
      "saveSuccess": "保存成功",
      "waitReview": "保存成功，等待发起审核",
      "successPublish": "发布成功",
      "publishFail": "发布失败，",
      "policyConflict": "会签策略下,“驳回规则”不允许“动态选择驳回目标节点”，请修改！",
      "noPermissionToSave": "当前用户不具备另存流程的权限",
      "closeProc1": "关闭此页面？",
      "closeProc2": "系统可能不会保存您所做的更改。",
      "closeProc3": "系统可能不会保存另存为后的页面或所作得修改",
      "viewModel": "查看模型",
      "copied": "模型已经复制到剪贴板",
      "releaseCheckPrompt": "当前流程为审核状态，需要等到审核完成后，才可进行下一次发布",
      "checkProcessCategoryExist": "请确认环境中是否存在该流程设计对应的流程分类",
      "processIsExist": "请确认当前流程定义是否被删除",
      "button": {
        "saveProc": "保存",
        "releaseProc": "发布",
        "sync": "同步设计时包",
        "saveAs": "另存为",
        "procRecord": "流程记录",
        "viewProcModel": "查看模型",
        "closeProc": "关闭"
      }
    },
    "designer": {
      "wfEditorUi": {
        "basicElements": "基本元素",
        "readOnly": "只读"
      },
      "wfProcessCell": {
        "basicInfo": "基本信息",
        "name": "名称",
        "nameLanguage": "名称",
        "key": "标识",
        "entryForm": "流程分类",
        "startMode": "启动方式",
        "wfTitle": "流程摘要",
        "formDef": "表单定义",
        "formsPC": "PC表单",
        "formsMobile": "移动表单",
        "process": "事件监听",
        "advanced": "高级属性",
        "basic": "基础属性",
        "wfComponent": "流程构件",
        "otherConfig": "其他配置",
        "processVariables": "流程变量",
        "basicElements": "基本元素",
        "customizeAction": "自定义动作",
        "timelinessInfo": "时效信息",
        "enablePriority": "启用紧急程度",
        "enableWholeOrderRetrieve": "撤回在审单据",
        "messageProperty": "影像设置",
        "timeLimitControl": "超时操作",
        "messageNotice": "消息通知",
        "extendProperty": "扩展属性",
        "directTips": "提示：启动方式切换为直接，直接启动是默认的流程启动方式，切换后会移除共享(PF)相关构件，请知悉！",
        "externalTips": "提示：启动方式切换为外部流程，适用于作为共享流程的外部流程相关场景，切换后保留流程上的共享（PF)相关构件，请知悉！",
        "subprocessTips": "提示：启动方式切换为子流程，适用于调用式子流程的场景，切换后会移除除取数构件外的其他流程构件，请知悉！"
      },
      "WfSequenceFlowEdge": {
        "basicInfo": "基本信息",
        "basic": "基础属性",
        "name": "名称",
        "nameLanguage": "名称",
        "id": "标识",
        "condition": "条件选项",
        "ConditionExpression": "条件",
        "default": "缺省转移线"
      },
      "wfSidebar": {
        "bizactivitylib": "业务活动"
      }
    },
    "app": {
      "processDesigner": {
        "all": "所有",
        "assign": "指派",
        "claim": "领用",
        "preempt": "抢占模式",
        "parallel": "并行会签",
        "sequential": "串行会签",
        "true": "是",
        "false": "否",
        "dataId": "单据内码",
        "procInstId": "流程实例ID",
        "bizDefKey": "入口单据ID",
        "processDefinitionKey": "流程定义KEY",
        "procInstCreator": "流程发起人",
        "businessCreator": "业务发起人",
        "procInstDescription": "流程摘要",
        "comment": "审批意见",
        "bizDefName": "流程分类名称",
        "curLoginUsername": "当前登录人名称",
        "procInstCreatorName": "流程发起人名称",
        "currentParticipantId": "当前办理人ID",
        "currentParticipantName": "当前办理人名称",
        "currentUser": "当前登录用户",
        "preActExecutors": "上一个活动的执行人",
        "collectionElementVariable": "多实例子活动元素变量",
        "subCollectionElementVariable": "多实例子流程元素变量",
        "nrOfInstances": "多实例总数量",
        "nrOfCompletedInstances": "多实例已完成数量",
        "nrOfActiveInstances": "多实例正在运行中的数量",
        "nrOfForward": "通过实例数量",
        "nrOfBackward": "驳回实例数量",
        "nrOfAbort": "终止实例数量",
        "conclusionType": "结论类型",
        "conclusionValue": "结论值",
        "directSuperior": "直接上级",
        "higherSuperior": "间接上级",
        "DIRECT": "直接",
        "EXTERNAL_PROCESS": "外部流程",
        "SUB_PROCESS": "子流程",
        "ALL": "电脑端和移动端",
        "WEB": "电脑端",
        "APP": "移动端",
        "conclusionTypeTips": "审批项流转方向，1正向，2反向，3终止",
        "conclusionValueTips": `审批项编号，例如，"Pass"、"Back"、"Refuse"`,
        "copy": "_副本",
        "saveAs": "另存为",
        "tips": "系统提示",
        "saveAsSuccess": "另存为成功",
        "saveAsFail": "另存为失败，请检查流程是否正确！",
        "syncDt": "是否将当前版本流程定义同步到设计时流程定义包",
        "checkExpressionAfterSaveAs": "模型校验失败，请检查并修改流程中的表达式配置",
        "clickOk": "确认",
        "ignoreAndContinue": "忽略并继续",
        "processCategoryNotFound": "请重新检查流程，未找到流程分类信息",
        "syncSuccess": "同步成功",
        "beforeCompleteStrategyChange": "当前节点存在运行中的活动实例，不允许调整完成策略，请了解！",
        "releaseProcess": "发布前审核",
        "auto": "自动生单",
        "push": "推式生单",
        "pull": "拉式生单",
        "creation": "通过生单流程生成目标单"
      }
    },
    "multiInstanceLoopCharacteristics": {
      "loopCharacteristics": "多实例设置",
      "set": "（已设置）",
      "notSet": "（未设置）",
      "isEnable": "是否启用",
      "isSequential": "是否串行",
      "loopCardinality": "元素集合",
      "completionConditionRules": "完成条件",
      "promptAct1": "1、[集合]中的元素个数为子活动启动实例数量。",
      "promptAct2": "2、子活动启动时系统会将[集合]中的元素拆分映射到各个子活动实例的[元素变量]。",
      "promptProc1": "1、[集合]中的元素个数为子流程启动实例数量。",
      "promptProc2": "2、子流程启动时系统会将[集合]中的元素拆分映射到各个子流程实例的[元素变量]。",
      "checkPrompt": "当前节点存在运行中的活动实例，不允许调整",
      "completeSave": "请配置完成条件，并点确认进行保存",
      "elementNotEmpty": "元素集合不允许为空",
      "conditionRulesSet": "（已设置）",
      "conditionRulesUnSet": "（未设置）",
      "enableForbid": "驳回规则中返回设置为[返回我]或者勾选[允许修改返回设置]时，不允许启用多实例设置",
      "completionConditionRulesList": {
        "forward": "正向",
        "backward": "反向",
        "abort": "终止"
      }
    },
    "component": {
      "optins": {
        "wfOptions": "工作流选项",
        "specified": "指定子流程",
        "dynamic": "动态子流程",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "subProcessType": "子流程类型",
        "processType": "流程类型",
        "bizDef": "流程分类",
        "procDef": "流程定义",
        "clickCancel": "取消",
        "clickOk": "确定"
      },
      "voConfig": {
        "documentInfo": "单据信息",
        "viewModelSelection": "视图模型选择",
        "cancel": "取消",
        "clickOk": "确定",
        "selectOne": "确定",
        "documentTypeSelect": "单据类型选择",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "viewModel": "视图模型",
        "documenttype": "单据类型",
        "placeholder": "请选择"
      },
      "variableSetting": {
        "constant": "常量",
        "expression": "表达式",
        "component": "构件",
        "ACTIVITY_STARTED": "活动开始",
        "ACTIVITY_COMPLETED": "活动结束",
        "varAssign": "变量赋值",
        "varNumber": "变量编号",
        "REQUIRED": "必填",
        "varName": "变量名称",
        "valueType": "值类型",
        "executionTime": "执行时机",
        "valueText": "变量值",
        "processVariables": "流程变量",
        "notSelectedVar": "尚未选中变量！",
        "valueCannotEmpty": "变量值不允许为空！",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "add": "新增",
        "delete": "删除",
        "serialNumber": "序号",
        "clickCancel": "取消",
        "clickOK": "确定",
        "inconsistentParameters": "当前构件方法参数不一致，请更新！",
        "methodNotExist": "当前构件已不存在此方法，请更新！",
        "parameterName": "参数名",
        "parameterValue": "参数值",
        "methodnotSelected": "尚未选择构件方法",
        "metadataNotExist": "帮助元数据不存在，请联系系统管理员查看原因！",
        "errorObtainComponent": "获取解析构件出错",
        "componentSelection": "构件选择",
        "componentName": "构件名称",
        "parameterList": "参数列表",
        "lineNumber": "序号"
      },
      "urgeHandleRule": {
        "urgentApproval": "催办审批：",
        "pleaseApprove": "请您尽快审批",
        "soOn": "的",
        "urgeHandle": "催办",
        "noSendingMethod": "尚未选择发送方式！",
        "setMessageTemplate": "消息渠道启用短信时需设置消息模板",
        "codeEmpty": "短信模板编号不允许为空",
        "noMessageSubject": "尚未配置消息主题！",
        "noMessageContent": "尚未选择消息内容！",
        "earliestTimeNotEmpty": "最早允许催办时间不允许为空",
        "minimumTimeNotEmpty": "最小允许催办间隔不允许为空",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "enableUrgeHandle": "启用催办",
        "timeSetting": "时间设置",
        "earliestTime": "最早允许催办时间（小时）",
        "minimumInterval": "最小允许催办间隔（小时）",
        "sendingMethod": "发送方式",
        "messageSubject": "消息主题",
        "supportEditing": "支持编辑",
        "messageContent": "消息内容",
        "displayReminder": "显示催办人",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "titleExpression": {
        "zh-CHS": "中文简体",
        "zh-CHT": "中文繁体",
        "en": "英文",
        "taskDescription": "任务描述",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "currentLanguage": "当前摘要语言:",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "timeLimitControl": {
        "timedOutOperation": "超时操作",
        "constant": "固定值",
        "scope": "时间范围",
        "day": "天",
        "hour": "时",
        "minute": "分",
        "BeforeDuration": "到期之前",
        "OnDuration": "到期时",
        "AfterDuration": "到期之后",
        "SendMessageExpireOperation": "超时预警",
        "AutoHandleExpireOperation": "自动办理",
        "curDay": "当天",
        "durationType": "期限类型",
        "required": "必填",
        "timeDuration": "时长",
        "timeUnit": "单位",
        "operationTypeName": "操作类型名称",
        "sendType": "操作",
        "onlyBeInteger": "任务期限只能是整数！",
        "setOperation": "请设置超时操作！",
        "setType": "请设置自动办理类型！",
        "setComments": "请设置自动办理意见！",
        "selectedOperation": "尚未选中预警操作！",
        "notSupportAutomatic": "下一节点是由当前办理人指派的话，当前节点不支持任务自动办理",
        "warningMessage": "预警消息",
        "automaticProcessing": "自动办理",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "timelinessControl": "任务处理时效控制",
        "isEnable": "是否启用",
        "taskDeadline": "任务期限",
        "timelyOperation": "时效预警操作",
        "actionList": "操作列表",
        "add": "新增",
        "remove": "删除",
        "clickCancel": "取消",
        "clickOK": "确定",
        "workItemParticipant": "当前节点办理人",
        "procInstCreator": "流程发起人",
        "to-doMessageTimeOut": "您有一条待办消息即将超时。",
        "messageTimeOut": "您有一条消息即将超时",
        "agree": "同意"
      },
      "sendMessageOperation": {
        "procInstCreator": "流程发起人",
        "workItemParticipant": "当前节点办理人",
        "preActExecutors": "上一节点办理人",
        "day": "天",
        "hour": "时",
        "minute": "分",
        "cycleTimeNotEmpty": "循环时间间隔不允许为空！",
        "sendMethodNotEmpty": "发送方式不允许为空！",
        "subjectNotEmpty": "消息主题不允许为空！",
        "contentNotEmpty": "消息内容不允许为空！",
        "recipientNotEmpty": "接收人不允许为空！",
        "messageTemplate": "消息渠道启用短信时需设置消息模板",
        "smsTemplateNumberNotEmpty": "短信模板编号不允许为空",
        "cycleEnable": "启用循环预警",
        "cycleTime": "循环时间间隔",
        "sendType": "发送方式",
        "subject": "消息主题",
        "message": "消息内容",
        "receiverVari": "接收人",
        "sysUsers": "系统用户",
        "clickCancel": "取消",
        "clickOK": "确定",
        "opinionsNotEmpty": "自动办理意见不允许为空！",
        "processingNotEmpty": "自动办理不允许为空！",
        "automaticProcessSet": "自动办理设置",
        "automaticProcessMethod": "自动办理方式",
        "automaticOpinionHandle": "自动办理意见"
      },
      "smsMessageTemplate": {
        "smsTemplateContent": "第三方短信服务商里定义的模板原文，例如:阿里云您的管控大数据平台账号已开通,用户名为:${username}，初始密码为:${code}，请及时登录系统",
        "code": "变量",
        "value": "值",
        "noRowsSelected": "尚未选中行",
        "smsMessageTemplate": "短信服务模板",
        "tips1": "消息模板是指已经在第三方短信服务商定义模板后，需要在GS Cloud里将短信服务商的模板变量和GS Cloud变量关联",
        "tips2": "第三方短信服务商里定义的模板编号，例如: 阿里云 SMS_220626324",
        "tips3": "将第三方短信服务商模板里的变量和GSCloud里的变量配置关联",
        "smsTemplateNumber": "短信模板编号",
        "smsVariableBinding": "短信变量绑定",
        "addSmsVariable": "新增",
        "deleteSmsVariable": "删除"
      },
      "signRule": {
        "countersignRules": "会签规则",
        "byNumber": "按数量",
        "byProportion": "按比例(%)",
        "customConditions": "自定义条件",
        "value": "编号",
        "text": "名称",
        "conclusionName": "结论名称",
        "conclusionValue": "结论值",
        "calculateType": "计算方式",
        "conditionValue": "条件值",
        "waitAllVotes": "等待全员办结",
        "yes": "是",
        "no": "否",
        "notEmpty": "完成策略为会签时，会签规则不允许为空，请了解！",
        "conditionNotEmpty": "计算方式设置为自定义条件时，自定义条件不能为空！",
        "pleaseSelect": "请首先选中一条审批项！",
        "maxConditionValue": "条件值最大值是100",
        "minConditionValue": "条件值最小值是0",
        "noConditional": "结论执行方式为全票或一票时不需要条件值",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "ruleList": "规则列表",
        "approvalOptions": "审批选项",
        "clickCancel": "取消",
        "deleteRow": "重置",
        "clickOK": "确定",
      },
      "saveAsEdit": {
        "public": "公有",
        "private": "私有",
        "code": "编号",
        "name": "名称",
        "nameNotEmpty": "流程名称不能为空",
        "organizationNotEmpty": "维护组织不能为空",
        "organization": "组织",
        "basicAttributes": "基础属性",
        "processName": "流程名称",
        "processKeyValue": "流程Key值",
        "thisDocument": "本单据内",
        "otherDocument": "其他单据",
        "entryFormEmpty": "未选择流程分类，请选择流程分类或将另存位置切换为本单据内！",
        "entryForm": "流程分类",
        "savePos": "另存位置",
        "maintenanceOrg": "维护组织",
        "accessLevel": "访问级别",
        "saveAsCancel": "取消",
        "saveAsOK": "确定"
      },
      "release": {
        "release": "流程发布",
        "update": "流程更新",
        "applicantName": "申请人名称",
        "applicantDepartment": "申请人部门",
        "procName": "流程名称",
        "procVersion": "流程版本",
        "releaseType": "发布类型",
        "textDetail": "说明",
        "saveAsCancel": "取消",
        "saveAsOK": "确定"
      },
      "processVariables": {
        "string": "字符",
        "integer": "整形",
        "decimal": "小数",
        "boolean": "布尔",
        "constant": "常量",
        "expression": "表达式",
        "component": "构件",
        "name": "变量编号",
        "required": "必填",
        "documentation": "变量名称",
        "basicType": "变量类型",
        "description": "描述",
        "tag": "初始值类型",
        "valueText": "初始值",
        "processVariables": "流程变量",
        "notSelected": "尚未选中流程变量！",
        "variableNumberEmpty": "变量编号不允许为空！",
        "variableNameEmpty": "变量名称不允许为空！",
        "variableNumberNotStandard": "变量编号只能包含字母、数字和下划线，且不能以数字开头！",
        "tagNotEmpty": "初始值类型不允许为空！",
        "codeDuplicates": "流程变量编号不允许重复！",
        "alreadyExists": "新增的变量已存在！",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "add": "新增",
        "delete": "删除",
        "number": "序号",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "participant": {
        "user": "用户",
        "variable": "变量参与者",
        "position": "岗位",
        "role": "角色",
        "component": "构件参与者",
        "reportingLine": "汇报关系",
        "matrix": "矩阵",
        "activityExecutor": "历史活动办理人",
        "organization": "单位/部门",
        "all": "所有",
        "assign": "指派",
        "claim": "领用",
        "currentUser": "当前办理人",
        "procInstCreator": "流程发起人",
        "participantSet": "参与者设置",
        "order": "序号",
        "type": "类型",
        "performerName": "名称",
        "description": "描述",
        "condition": "启用条件",
        "dataMovement1": "是否将默认办理人数据移动到到备选办理人？",
        "dataMovement2": "是否将备选办理人数据移动到默认办理人？",
        "participantSelection": "参与者选择",
        "selectProcessVariables": "尚未选择流程变量！",
        "selectVariableValueType": "尚未选择变量值类型！",
        "selectRelation": "尚未选择关系！",
        "selectPosition": "尚未选择岗位！",
        "selectOrgType": "尚未选择组织类型！",
        "orgFill": "尚未填写组织！",
        "refOrgIdNotNull": "参照类型为组织时，参照组织字段不能为空",
        "refUserIdNotNull": "参照类型为系统用户/员工时，参照人字段不能为空",
        "repDefConfigured": "该汇报关系已经进行过配置",
        "atLeastOneCondition": "条件字段至少要存在一个",
        "dataFieldAliasNotNull": "数据字段不能为空",
        "matrixConfigured": "该矩阵已经进行过配置",
        "selectPerformer": "尚未选择参与者",
        "definitionDeleted": "该条汇报关系数据的定义已删除，该条数据将删除",
        "matrixDeleted": "该条矩阵数据的定义已删除，该条数据将删除",
        "selectParticipantInfo": "请先选中一条参与者信息！",
        "noRowSelected": "尚未选中行！",
        "selectDefaultHandler": "请先选中一条默认办理人",
        "selectpotentialtHandler": "请先选中一条备选办理人",
        "org": "组织：",
        "positionType1": "岗位类型：通用岗位，组织：",
        "positionType2": "岗位类型：通用岗位",
        "positionType3": "岗位类型：组织岗位",
        "comp": "构件：",
        "parameters:": ",参数：{",
        "referencePerson:": "参照人：",
        "referenceOrganization:": "参照组织：",
        "code": "编号：",
        "condition1": "条件1：",
        "condition2": "条件2：",
        "condition3": "条件3：",
        "data": "数据：",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "allocationPolicy": "分配策略",
        "operator": "指派操作人",
        "multiSelect": "允许多选",
        "necessary": "只有一个待选用户时，仍需手工选择",
        "notifyRecipient": "知会接收人",
        "defaultHandler": "默认办理人",
        "new": "新增",
        "editPerformer": "编辑",
        "removePerformer": "移除",
        "clearPerformer": "清空",
        "moveUp": "上移",
        "moveDown": "下移",
        "alternativeHandler": "备选办理人",
        "isAllScope": "指定参与人时不限范围，从全员用户中选择",
        "clickCancel": "取消",
        "clickOK": "确定",
        "alternativeScope": "备选范围",
        "orgId": "组织ID",
        "includeChildren": "包含下级",
        "conditon": "启用条件",
        "currentUnit": "本单位",
        "currentDepartment": "本部门",
        "variableOrganization": "变量组织"
        // "assignOrganization": "指定组织"
      },
      "activityExecutor": {
        "name": "名称",
        "eventHandler": ">活动办理人",
        "nodeName": "节点名称",
        "enablingConditions": "启用条件",
        "activityList": "活动列表",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "componentPerformer": {
        "componentMethod": "当前构件方法参数不一致，请更新！",
        "methodNotExist": "当前构件已不存在此方法，请更新！",
        "code": "编号",
        "name": "名称",
        "description": "描述",
        "valueText": "参数值",
        "help": "帮助",
        "errorObtaining": "获取解析构件出错",
        "componentSelection": "构件选择",
        "metadataNotExist": "帮助元数据不存在！",
        "serverSideNotFound": "服务器端未找到帮助元数据，请检查元数据是否已经部署到环境中",
        "componentName": "构件名称",
        "componentSelect": "构件选择",
        "parameterList": "参数列表"
      },
      "matrixPerformer": {
        "code": "编号",
        "name": "名称",
        "help": "帮助",
        "multivalue": "多值",
        "enumSelection": "枚举选择",
        "refMatrixTable": "引用矩阵表",
        "matrixTable": "矩阵表",
        "curDataFieldValue": "结果列",
        "conditionFields": "条件字段",
        "condition": "启用条件",
        "key": "键",
        "value": "值",
        "notSelectEnum": "尚未选中枚举值",
        "cancel": "取消",
        "onConfirm": "确定",
        "lineNumber": "序号"
      },
      "performerOptions": {
        "leave": "向下流转",
        "throwException": "异常提示",
        "sys": "用户ID",
        "administrative_staff": "员工ID",
        "procInstCreator": "流程发起人",
        "preActExecutors": "上一节点办理人",
        "allPassExecutors": "所有已办理人员",
        "performerOptions": "参与者选项",
        "exclusionNotAllowed": "所有已办理人员已设置自动审批，上个节点已办理人员默认不允许排除！",
        "approvalNotAllowed": "【分配策略】为【领用】时，不允许设置自动审批，请了解！",
        "approvalNotAllowedAsSet": "所有已办理人员已设置不允许审批，所以上个节点已办理人员默认不允许自动审批！",
        "allocationStrategyIsCollect": "【分配策略】为【领用】时，不允许设置自动审批，请了解！",
        "set": "（已设置）",
        "advancedOptions": "参与者高级选项",
        "historicFirst": "再次进入节点时，办理人是节点的已办人员",
        "noPerformerStrategy": "办理人为空策略：",
        "excludeProcInstCreator": "排除办理人选项",
        "defaultNotParticipate": "流程发起人默认不参与审批",
        "excludePreActExecutors": "上个节点已办理人员默认不参与审批",
        "excludeAllPassExecutors": "所有已办理人员默认不参与审批",
        "excludeExprPerformer": "流程变量：",
        "variableOrgTypes": "变量值类型：",
        "automaticApprovalOptions": "自动审批选项",
        "autoProcInstCreator": "流程发起人默认自动审批通过",
        "autoPreActExecutors": "上一节点办理人员默认自动审批通过",
        "autoAllPassExecutors": "所有已办理人员默认自动审批通过",
        "cancel": "取消",
        "clickOK": "确定"
      },
      "positionPerformer": {
        "orgPosition": "组织岗",
        "generalPosition": "通用岗",
        "sysPositions": "系统岗位",
        "positionType": "岗位类型",
        "role": "角色",
        "position": "岗位",
        "sysType": "组织类型",
        "placeholder": "请选择",
        "orgId": "组织ID",
        "condition": "启用条件",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "reportingLine": {
        "higherSuperior": "间接上级",
        "directSuperior": "直接上级",
        "code": "编号",
        "name": "名称",
        "dept": "组织",
        "sysUser": "系统用户",
        "employee": "员工",
        "businessFields": "业务字段",
        "defName": "汇报定义",
        "dimension": "汇报级别",
        "curReportingRefer": "参照类型",
        "usersName": "参照人",
        "refOrgId": "参照组织",
        "condition": "启用条件",
        "definitionOfReport": "汇报关系定义"
      },
      "userPerformer": {
        "regularUser": "固定用户",
        "variablePart": "变量参与者",
        "sys": "系统用户",
        "administrative_organization": "员工",
        "cantUseContext": "行政人员类型不能使用此上下文变量",
        "user": "用户",
        "variable": "变量",
        "condition": "启用条件"
      },
      "variablePerformer": {
        "sys": "用户ID",
        "administrative_staff": "员工ID",
        "oneself": "本人",
        "administrative_organization": "部门ID",
        "cantUseContext": "行政人员类型不能使用此上下文变量",
        "processVariables": "流程变量",
        "variableOrgTypes": "变量值类型",
        "relationShipType": "关系",
        "condition": "启用条件",
      },
      "orgPotentialOwner": {
        "optionSettings": "选项设置",
        "global": "全员",
        "currentUnit": "本单位",
        "currentDepartment": "本部门",
        "addSignBehind": "加签",
        "addSignFront": "征询",
        "transfer": "移交",
        "notify": "知会",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "option": "选项",
        "enable": "是否启用",
        "range": "范围",
        "orgId": "组织ID",
        "variableOrganization": "变量组织",
        "includeChildren": "包含下级",
        "clickCancel": "取消",
        "clickOK": "确定",
        "limit": "限定人员范围",
        "turnOffPrompt": "请关闭限定人员范围选项"
      },
      "note": {
        "placeholder": "请输入流程变更记录",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "MessageNotice": {
        "notify": "消息通知",
        "subject": "消息主题",
        "content": "消息内容",
        "sendTime": "发送时机",
        "sendType": "发送方式",
        "receiverText": "消息接收人",
        "procInstCreator": "流程发起人，",
        "workItemParticipant": "任务接收人，",
        "messageSet": "消息设置",
        "selectedRow": "尚未选中消息通知！",
        "noCopy": "没有待复制的消息通知属性！",
        "batchCopy": "批量复制",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "add": "新增",
        "edit": "编辑",
        "delete": "删除",
        "lineNumber": "序号",
        "clickCancel": "取消",
        "clickOK": "确定",
        "messContent": `{"expr":"\'您有一条消息通知。\'","sexpr":""}`,
        "procComplete": "流程完成",
        "procAborted": "流程终止",
        "procRollBack": "流程驳回",
        "workCreated": "任务创建",
        "workAborted": "任务终止",
        "actComplete": "活动完成",
        "actAborted": "活动终止",
        "email": "邮件",
        "sms": "短信",
        "cloudplus": "云",
        "processParticipant": "流程参与人",
        "variableParticipant": "变量参与者",
        "userParticipant": "指定用户",
        "positionParticipant": "岗位",
        "activityExecutorParticipant": "历史办理人",
        "sys": "系统用户",
        "administrative_organization": "员工",
        "name": "名称",
        "noTargetNode": "尚未选中节点！",
        "noMessageNotifyAttribute!": "没有消息通知属性！"
      },
      "messageNoticeEdit": {
        "procInstCreator": "流程发起人",
        "activityExecutorParticipant": "历史办理人",
        "workItemParticipant": "任务办理人",
        "sys": "系统用户",
        "administrative_organization": "员工",
        "processParticipant": "流程参与人",
        "workItemReceiveParticipant": "任务接收人",
        "variableParticipant": "变量参与者",
        "userParticipant": "指定用户",
        "positionParticipant": "岗位",
        "sendType": "发送方式不允许为空",
        "smsMessageTemplate": "消息渠道启用短信时需设置消息模板",
        "smsMessageTemplateCode": "短信模板编号不允许为空",
        "sendTime": "发送时机不允许为空",
        "subject": "消息主题不允许为空",
        "content": "消息内容不允许为空",
        "receivers": "接收人不允许为空！",
        "processParticipantNotNull": "流程参与人不允许为空",
        "activityDefIdNotNull": "流程参与人为历史办理人时，办理节点不允许为空",
        "variableParticipantNotNull": "变量参与者不允许为空",
        "orgType": "变量参与者组织类型不允许为空",
        "userIds": "指定用户不允许为空",
        "positionId": "岗位不允许为空",
        "activityList": "活动列表",
        "position": "岗位",
        "optionalNodes": "可选节点",
        "targetNodeList": "目标节点列表",
        "placeholder": "请选择目标节点",
        "optionalAttribute": "可选属性",
        "lineNumber": "序号",
        "clickCancel": "取消",
        "clickOK": "确定",
        "messSendType": "消息渠道",
        "messSubject": "消息主题",
        "enable": "启用表达式",
        "messContent": "消息内容",
        "recipient": "接收人",
        "addReceiver": "添加",
        "organization": "组织：",
        "posi": "岗位："
      },
      "jumpScope": {
        "targetNodeOptions": "目标节点选项",
        "name": "名称",
        "outConnectNode": "流程图连线节点",
        "global": "流程内所有节点",
        "afterNodes": "所有后继节点",
        "specifiedSet": "流程图连线节点+附加节点",
        "firstNode": "条件为true的连线节点，当有多条时默认选中首条",
        "nullNode": "默认为空，每次都手动选择",
        "specifyNode": "指定默认节点",
        "noSetTargetNode": "尚未设置目标节点选项，请了解！",
        "noSetSpecifyNode": "尚未指定默认节点，请了解！",
        "selectedRow": "请首先选中一条选项！",
        "optionalNodes": "可选节点",
        "listOfAdditional": "附加节点列表",
        "pleaseSelect1": "请选择附加节点",
        "defaultNode": "默认节点",
        "pleaseSelect2": "请选择默认节点",
        "defaultNodeList": "默认节点列表",
        "clickCancel": "取消",
        "clickOK": "确定",
        "set": "（已设置）"
      },
      "imageSet": {
        "imageSet": "影像设置",
        "onlyView": "仅可查看",
        "edit": "编辑",
        "reScanStart": "发起重扫",
        "reScanComplete": "重扫完成",
        "mutualExclusion": "【仅可查看】选项与其他选项互斥，请了解！",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "imageOperation": "影像操作权限",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "extendProperty": {
        "extendProperty": "扩展属性",
        "true": "是",
        "false": "否",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "illustrate": "说明",
        "placeholder": "请选择",
        "cancel": "取消",
        "clickOK": "确定"
      },
      "expressionEditor": {
        "expressionEditor": "条件编辑",
        "notSet": "（未设置）",
        "clickCancel": "取消",
        "changeType": "切换类型",
        "clickOK": "确定"
      },
      "executeForms": {
        "executeForms": "表单定义",
        "parameters": "参数【",
        "typeAsvariable": "】类型为变量，但在流程变量里不存在",
        "parameterSettings": "参数设置",
        "formDefinitionList": "表单定义列表",
        "notSet": "（未设置）",
        "default": "流程默认表单",
        "processEmbeddedForm": "流程嵌表单",
        "formEmbedProcess": "表单嵌流程",
        "clickCancel": "取消",
        "clickOK": "确定",
        "noForm": "暂无表单格式",
        "form": "选择表单",
        "placeholder": "请选择",
        "parametersSet": "参数",
        "key": "变量编号",
        "name": "变量名称",
        "lineNumber": "序号",
        "code": "编号",
        "paramName": "名称",
        "tag": "类型",
        "value": "参数值",
        "variable": "变量",
        "constant": "常量",
        "expression": "表达式",
        "method": "方法标识",
        "methodName": "方法名称",
        "description": "描述",
        "workFlowAction": "流转方向",
        "formOperations": "表单操作",
        "executionTime": "执行时机",
        "sortOrder": "执行顺序",
        "methodParameters": "参数",
        "selectFormActionConfig": "尚未选中表单操作配置！",
        "selectFormAction": "尚未选中表单操作！",
        "editParam": "设置",
        "formEvents": "表单事件",
        "buttonName": "按钮名称",
        "enable": "是否可用",
        "disabled": "是否禁用",
        "hidden": "是否隐藏",
        "fieldName": "字段名称",
        "editable": "是否可写",
        "readonly": "是否只读",
        "required": "是否必填",
        "saveFail": "保存配置失败，请联系管理员查看原因！",
        "checkedRows": "尚未选择按钮集合",
        "checkeds": "尚未选择字段集合",
        "enableBtn": "可用",
        "disabledBtn": "禁用",
        "hiddenBtn": "隐藏",
        "btnBatchReset": "重置",
        "editableBtn": "可写",
        "readonlyBtn": "只读",
        "requiredBtn": "必填",
        "add": "新增",
        "delete": "删除",
        "other": "其他",
        "formBtn": "表单按钮",
        "formfield": "表单字段",
        "apptag": "单据类型",
        "functionMenu": "功能菜单",
        "formFormat": "表单格式",
        "docFormatNumber": "单据格式编号",
        "docFormatName": "单据格式名称",
        "selectedRow": "尚未选择表单定义！",
        "set": "（已设置）",
        "operationDelete": "该操作不允许删除",
        "operationAdd": "该操作无法新增",
        "alreadySelect": "该表单定义已被选择，请选择其他表单",
        "canAddSameOperation": "表单操作不允许重复"
      },
      "eventDefinition": {
        "eventDefinition": "信号定义",
        "pass": "正向",
        "back": "反向",
        "abort": "终止",
        "signalRef": "信号编号",
        "name": "信号名称",
        "triggerAction": "流转方向",
        "selectedRow": "尚未选中一条触发事件！",
        "dataLength": "至少需要一个信号定义，请了解！",
        "codeNotNull": "信号编号不允许为空！",
        "nameNotNull": "信号名称不允许为空！",
        "codeNotNumber": "信号编号不允许为纯数字！",
        "codeRepeat": "信号编号不允许重复！",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "add": "新增",
        "delete": "删除",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "entryFormEditor": {
        "flowForm": "流程分类",
        "code": "编号",
        "name": "名称",
        "base": "类型",
        "foundation": "基础",
        "extend": "扩展",
        "selectedRow": "尚未选择流程分类",
        "absent": "流程分类已经不存在",
        "lineNumber": "序号",
        "clickCancel": "取消",
        "clickOK": "重新绑定"
      },
      "editComponentParameter": {
        "code": "编号",
        "name": "名称",
        "required": "必填",
        "yes": "是",
        "no": "否",
        "value": "参数值",
        "openComponentFail": "获取解析构件出错",
        "componentSelection": "构件选择",
        "curComponent": "请选择流程构件",
        "executionTime": "请选择执行时机",
        "para": "参数",
        "paraRequired": "】必填",
        "execuTime": "执行时机",
        "parameterList": "参数列表",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "customizeAction": {
        "customizeAction": "自定义动作",
        "app": "移动",
        "web": "web",
        "all": "web,移动",
        "name": "名称",
        "code": "编号",
        "terminalType": "适用终端",
        "isAll": "是否默认",
        "yes": "是",
        "no": "否",
        "paramName": "编号",
        "valueText": "名称",
        "value": "参数值",
        "addActions": "自定义动作选择",
        "actionExisted": "新增的自定义动作已经存在！",
        "selectedRow": "请首先选中一条选项！",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "add": "新增",
        "delete": "删除",
        "parameterList": "参数列表",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "checkCondition": {
        "zhChs": "简体中文",
        "zhCht": "繁体中文",
        "en": "英文",
        "checkCondition": "活动校验规则",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "nodeEntry": "节点进入",
        "activityBeforeStarted": "节点进入条件",
        "enterErrorTips": "进入条件不匹配提示语",
        "activityBeforeCompleted": "节点离开",
        "activityBeforeCompletedValue": "节点离开条件",
        "leaveErrorTips": "离开条件不匹配提示语",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "batchSet": {
        "targetNode": "目标节点",
        "addSignFront": "征询",
        "addSignBehind": "加签",
        "transfer": "移交",
        "notify": "知会",
        "backWardRule": "驳回规则",
        "participantOptions": "参与者选项",
        "name": "名称"
      },
      "subProcess": {
        "subProcessSet": "子流程设置",
        "specified": "指定子流程",
        "dynamic": "动态子流程",
        "inheritParent": "与父流程相同",
        "autoCreation": "自动生成下游单据",
        "variablesExpression": "变量表达式",
        "rteNull": "请选中一条生单流程",
        "orderProcess": "生单流程",
        "clickOk": "确定",
        "clickCancel": "取消",
        "inheritBizDataId": "当子流程与父流程单据不一致时，请设置子流程单据内码！",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "radioGroupProcessType": "子流程类型",
        "flowForm": "流程分类",
        "processDef": "流程定义",
        "radioGroupBillSource": "单据来源",
        "autoCreationProcess": "生单流程",
        "bizDataId": "单据内码",
        "setOption": "设置选项",
        "SameParentProcess": "与父流程同一张业务单据",
        "setBizDataId": "设置单据内码",
        "subProcessOpt": "子流程选项"
      },
      "backwardRule": {
        "reEdit": "驳回活动节点已不存在，请重新编辑",
        "backwardRule": "驳回规则",
        "initialActityId": "开始节点",
        "precursorActivityId": "前置节点",
        "empty": "空",
        "name": "名称",
        "id": "标识",
        "sequence": "顺序流转",
        "backToMe": "返回我",
        "backToCurrentNode": "返回本节点",
        "popover": "1.顺序流转:按照流转线顺序进行流转; 2.返回我:完成策略为抢占：只给驳回人创建任务,完成策略为会签：驳回人与未审批人收到新任务，已审批人员自动审批通过; 3.返回本节点:实际效果受“再次进入节点时，办理人是否是节点已办人员影响”选项的影响",
        "selectAbleClick": "会签策略下，不允许动态选择驳回目标节点!",
        "dictPicked": "“驳回至空”选项请搭配“允许动态选择驳回目标节点”使用",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "rejectedTo:": "驳回至：",
        "backScope": "驳回范围",
        "defaultPrompt": "默认选取全部历史驳回节点",
        "title": "活动列表",
        "dynamicSelection": "允许动态选择驳回目标节点",
        "resubmitEffectOptions": "返回设置",
        "popover1": "1.顺序流转:按照流转线顺序进行流转; ",
        "popover2": "2.返回我:完成策略为抢占：只给驳回人创建任务,完成策略为会签：驳回人与未审批人收到新任务，已审批人员自动审批通过;",
        "popover3": "3.返回本节点:实际效果受“再次进入节点时，办理人是否是节点已办人员影响”选项的影响",
        "allowModification": "允许修改返回设置",
        "dynamicBackWardRuleAbleClick": "开启多实例后，禁止勾选允许修改返回设置",
        "backToMeForbid": "开启多实例后，禁止选择返回我",
        "clickCancel": "取消",
        "clickOk": "确定"
      },
      "assignStrategy": {
        "all": "所有",
        "assign": "指派",
        "claim": "领用",
        "currentUser": "当前办理人",
        "procInstCreator": "流程发起人",
        "assignStrategy": "分配策略",
        "option": "选项",
        "assignmentRules": "指派规则",
        "operator": "指派操作人",
        "multiSelect": "允许选择多个待选用户",
        "necessary": "只有一个待选用户时，仍需手工选择",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "assignScope": {
        "assignScopeList": "指派节点列表",
        "required": "必填",
        "yes": "是",
        "no": "否",
        "condition": "条件",
        "add": "增加",
        "delete": "删除",
        "name": "名称",
        "deleteRow": "请首先选中一条选项！",
        "curActivity": "尚未选中行",
        "duplicateNodeNoAdd": "已选择节点不会重复增加",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "nodeList": "节点列表",
        "moveUp": "上移",
        "moveDown": "下移",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "assignPerformer": {
        "currentUser": "当前办理人",
        "procInstCreator": "流程发起人",
        "global": "全员",
        "currentUnit": "本单位",
        "currentDepartment": "本部门",
        "assignPerformer": "指派规则",
        "set": "（已设置）",
        "operator": "指派操作人",
        "multiSelect": "允许选择多个待选用户",
        "necessary": "只有一个待选用户时，仍需手工选择",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "approvelItems": {
        "approvalOptions": "审批选项",
        "forward": "正向",
        "backward": "反向",
        "abort": "终止",
        "value": "编号",
        "text": "名称",
        "workFlowAction": "流转方向",
        "isDefault": "默认",
        "no": "否",
        "yes": "是",
        "commentNecessary": "意见必填",
        "attachmentNecessary": "附件上传",
        "certification": "数字签名",
        "signatureNecessary": "手写签名必填",
        "defaultComment": "默认意见",
        "zh-CHS": "中文简体",
        "zh-CHT": "中文繁体",
        "en": "英文",
        "workFlowActionNotNull": "审批项流转方向不允许为空，请修改！",
        "deleteRow": "请首先选中一条选项！",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "add": "新增",
        "delete": "删除",
        "clickCancel": "取消",
        "clickOK": "确定",
        "approvalAction": "审批动作",
        "lineNumber": "序号"
      },
      "approvalPivot": {
        "remind": "文字提示",
        "type": "类型",
        "condition": "条件",
        "title": "显示名称",
        "description": "详细说明",
        "approvalPivot": "审批要点",
        "selectedRow": "尚未选中审批要点！",
        "configTitle": "尚未填写显示标题！",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "enable": "是否启用",
        "expand": "是否展开",
        "showTitle": "显示标题",
        "list": "列表",
        "add": "新增",
        "delete": "删除",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "anonymousSet": {
        "anonymousOpt": "匿名选项",
        "approver": "审批人",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "anonymousSet": "匿名设置",
        "isAnonymity": "是否启用",
        "anonymous": "匿名代称",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "activityList": {
        "name": "名称",
        "checkeds": "尚未选择活动节点",
        "lineNumber": "序号",
        "clickCancel": "取消",
        "clickOK": "确定"
      },
      "activityComponent": {
        "component": "构件",
        "method": "构件方法",
        "inconsistentParameters": "参数不一致，请检查",
        "longerExists": "构件已不存在此构件方法",
        "absent": "取消",
        "pleaseCheck": "，请检查",
        "edit": "编辑",
        "deleteRow": "删除",
        "executionTime": "执行时机",
        "cmpName": "构件名称",
        "metadataId": "构件ID",
        "methodCode": "构件方法",
        "isForCompensation": "补偿操作",
        "yes": "是",
        "no": "否",
        "operate": "操作",
        "code": "编号",
        "name": "名称",
        "value": "参数值",
        "editComponent": "编辑构件",
        "confirmDelete": "确认是否删除构件？",
        "curComponent": "尚未选中构件！",
        "newComponent": "新建构件",
        "selectComponent": "选择构件",
        "sameCmp": "存在相同的流程构件",
        "cmpMethod": "构件方法：",
        "executionTimeNotNull": "构件执行时机不允许为空！",
        "param": "的参数",
        "required": "必填",
        "set": "（已设置）",
        "notSet": "（未设置）",
        "PROCESSINSTANCE_STARTED": "流程启动",
        "PROCESSINSTANCE_SUSPENDED": "流程挂起",
        "PROCESSINSTANCE_RESUMED": "流程恢复",
        "PROCESSINSTANCE_COMPLETED": "流程完成",
        "PROCESSINSTANCE_ABORTED": "流程终止",
        "PROCESSINSTANCE_CANCELED": "流程取消",
        "PROCESSINSTANCE_REACTIVATED": "流程复活",
        "PROCESSINSTANCE_ROLLBACK": "流程驳回",
        "PROCESSINSTANCE_RESUBMIT": "重新提交",
        "ACTIVITY_AND_PARTICIPANT_UPDATED": "环节办理人变更",
        "PROCESSINSTANCE_ABORTED_BY_ADMIN": "管理员终止",
        "PROCESSINSTANCE_BEFORE_START": "流程启动前",
        "WORKITEM_BEFORE_COMPLETE": "任务完成前",
        "WORKITEM_AFTER_COMPLETE": "任务完成后",
        "LOADDATA": "获取数据",
        "ACTIVITY_STARTED": "活动启动",
        "ACTIVITY_COMPLETED": "活动完成",
        "ACTIVITY_ABORTED": "活动终止",
        "WORKITEM_CREATED": "工作项创建",
        "WORKITEM_COMPLETED": "工作项完成",
        "WORKITEM_SUSPENDED": "工作项挂起",
        "WORKITEM_RESUMED": "工作项恢复",
        "WORKITEM_ABORTED": "工作项终止",
        "WORKITEM_RETRIEVED": "工作项取回",
        "WORKITEM_CLAIMED": "工作项领用",
        "WORKITEM_UNCLAIMED": "工作项反领用",
        "ACTIVITY_ASSIGNMENT": "任务分配前",
        "deleteNotAllowed": "取数构件不允许删除，请了解！",
        "tips": "提示：",
        "prefabricated": "已经预制外部流程构件，此处只保留取数构件",
        "add": "新增",
        "moveUp": "上移",
        "moveDown": "下移",
        "clickCancel": "取消",
        "clickOK": "确定"
      }
    }
  },
  "en": {
    "validate": {
      "noProcessHeader": "processHeader attribute does not exist in the model",
      "cmpsEmpty": "Process component is empty",
      "cmpsEmptyMsg": "The process component cannot be empty, please contact the form development to confirm the problem",
      "directNoPf": "A process whose startup mode is [direct] should not contain shared (PF) process components",
      "directNoPfMsg": "Please remove the following process components of sharing (PF):",
      "noLoadDataCmp": "There is no process component whose execution opportunity is [get data]",
      "noLoadDataCmpMsg": "The process definition cannot be short of fetching components, please contact the form development to confirm the problem",
      "noStartCmp": "The process component whose execution opportunity is [Process Start] is missing",
      "noStartCmpMsg": "The document status cannot be modified when the process is started, please contact the form development to confirm the problem",
      "lackProcessCompleteCmp": "There is no process component whose execution opportunity is [Process Completion]",
      "lackProcessCompleteCmpMsg": "The document status cannot be modified when the process is completed, please contact the form development to confirm the problem",
      "lackProcessAbortCmp": "Lack of process component with execution timing of [process termination]",
      "lackProcessAbortCmpMsg": "The document status cannot be modified when the process is terminated, please contact the form development to confirm the problem",
      "lackProcessCancelCmp": "The process component with execution opportunity of [Process Termination] is missing",
      "lackProcessCancelCmpMsg": "The document status cannot be modified when the process is terminated, please contact the form development to confirm the problem",
      "lackProcessBackCmp": "Lack of process component with execution opportunity of [Process Rejection]",
      "lackProcessBackCmpMsg": "The document status cannot be modified when the process is rejected, please contact the form development to confirm the problem",
      "lackProcessReStartCmp": "Lack of process component with execution opportunity of [resubmit]",
      "lackProcessReStartCmpMsg": "It will lead to the failure to modify the document status when the process is resubmitted, please contact the form development to confirm the problem",
      "parallelGatewayCheck": "[Parallel Gateway] does not appear in pairs",
      "parallelGatewayCheckMsg": "[Parallel Gateway] needs to appear as a split node and a sink node of a process branch in pairs, please modify it",
      "inclusiveGatewayCheck": "[Inclusive Gateway] does not appear in pairs",
      "inclusiveGatewayCheckMsg": "[Inclusive Gateway] needs to appear as a split node and a sink node of a process branch in pairs, please modify it",
      "approvalPerformerCheck": "activity, no participant set",
      "notifyPerformerCheck": "node, no notification recipient set",
      "noVariable1": "A variable has been set in the variable setting attribute of the activity",
      "noVariable2": "It no longer exists in the process attribute Process Variable. Please modify it!",
      "noSignRule": "Node no sig rules have been set",
      "activity": "activity [",
      "noStartActivity": "] is illegal and does not start with [startActivity]",
      "noExclusiveGateway": "] is illegal and does not start with [ExclusiveGateway]",
      "noParallelGateway": "] is illegal and does not start with [ParallelGateway]",
      "noUserActivity": "] is illegal and does not start with [UserActivity]",
      "noOperationActivity": "] is illegal and does not start with [OperationActivity]",
      "noNotifyActivity": "] is illegal and does not start with [NotifyActivity]",
      "noCallActivitySubProcess": "] is illegal and does not start with [CallActivitySubProcess]",
      "noAutoActivity": "] is illegal and does not start with [AutoActivity]",
      "noIntermediateCatchEvent": "] is illegal and does not start with [MediaTechEventTimpl]",
      "noMessageActivity": "] is illegal and does not start with [MessageActivity]",
      "noAifCreationBillActivity": "] is illegal and does not start with [AifCreationBillActivity]",
      "noEndEvent": "] is illegal and does not start with [EndEvent]",
      "mark": "The logo is [",
      "noFlowNodeChsName": "] is empty, please modify it",
      "nameExceedsLengthLimit": "] is too long and cannot exceed 40 characters. Please modify it."
    },
    "processEditor": {
      "tip": "Tip",
      "showButton": "Show Model View Button",
      "changeRecord": "Process Change Record",
      "noDtInfo": "No design time process information exists! Please assign it first!",
      "noRtInfo": "No runtime process information exists! Please assign it first!",
      "wrongMoment": "Wrong moment for the editor!",
      "prompted": "System Prompt",
      "saveSuccess": "Save successful",
      "waitReview": "Save successful, awaiting review initiation",
      "successPublish": "Publish successful",
      "publishFail": "Publish failed,",
      "policyConflict": "In countersign strategy, 'Rejection Rule' does not allow 'Dynamic Select Rejection Target Nodes', please modify!",
      "noPermissionToSave": "The current user does not have permission to save the process",
      "closeProc1": "Close this page?",
      "closeProc2": "The system may not save the changes you made.",
      "closeProc3": "The system may not save the saved as page or the modifications made",
      "viewModel": "View Model",
      "copied": "The model has been copied to the clipboard",
      "releaseCheckPrompt": "The current process is in the review status and needs to wait until the review is completed before proceeding to the next release",
      "checkProcessCategoryExist": "Please confirm if there is a Process Category corresponding to the process design in the environment",
      "processIsExist": "Please confirm if the current process definition has been deleted",
      "button": {
        "saveProc": "Save",
        "releaseProc": "Publish",
        "sync": "Synchronize Design Time Package",
        "saveAs": "Save As",
        "procRecord": "Process Record",
        "viewProcModel": "View Model",
        "closeProc": "Close"
      }
    },
    "designer": {
      "wfEditorUi": {
        "basicElements": "Basic Elements",
        "readOnly": "Read-only"
      },
      "wfProcessCell": {
        "basicInfo": "Basic Information",
        "name": "Name",
        "nameLanguage": "Name",
        "key": "Identifier",
        "entryForm": "Process Category",
        "startMode": "Start Mode",
        "wfTitle": "Process Summary",
        "formDef": "Form Definition",
        "formsPC": "PC Form",
        "formsMobile": "Mobile Form",
        "process": "Event Listener",
        "advanced": "Advanced Properties",
        "basic": "Basic Properties",
        "wfComponent": "Process Component",
        "otherConfig": "Other Configuration",
        "processVariables": "Process Variables",
        "basicElements": "Basic Elements",
        "customizeAction": "Custom Actions",
        "timelinessInfo": "Timeliness Information",
        "enablePriority": "Enable Priority",
        "enableWholeOrderRetrieve": "Withdraw Documents Under Review",
        "messageProperty": "Image Setting",
        "timeLimitControl": "Timeout Operation",
        "messageNotice": "Message Notification",
        "extendProperty": "Extended Properties",
        "directTips": "Tip: Switching start mode to 'Direct' will remove shared (PF) related components as it is the default start mode. Please be aware of this!",
        "externalTips": "Tip: Switching start mode to 'External Process' is suitable for scenarios where the process serves as an external process for sharing. After switching, shared (PF) related components on the process will be retained. Please be aware of this!",
        "subprocessTips": "Tip: Switching start mode to 'Subprocess' is suitable for invoking sub-processes. After switching, all process components except those for data extraction will be removed. Please be aware of this!"
      },
      "WfSequenceFlowEdge": {
        "basicInfo": "Basic Information",
        "basic": "Basic Properties",
        "name": "Name",
        "nameLanguage": "Name",
        "id": "Identifier",
        "condition": "Condition Options",
        "ConditionExpression": "Condition Expression",
        "default": "Default Transition"
      },
      "wfSidebar": {
        "bizactivitylib": "Business Activity Library"
      }
    },
    "app": {
      "processDesigner": {
        "all": "All",
        "assign": "Assign",
        "claim": "Claim",
        "preempt": "Preempt Mode",
        "parallel": "Parallel Countersignature",
        "sequential": "Sequential Countersignature",
        "true": "Yes",
        "false": "No",
        "dataId": "Document ID",
        "procInstId": "Process Instance ID",
        "bizDefKey": "Entrance Document ID",
        "processDefinitionKey": "Process Definition Key",
        "procInstCreator": "Process Initiator",
        "businessCreator": "Business Initiator",
        "procInstDescription": "Process Summary",
        "comment": "Approval Comment",
        "bizDefName": "Process Category Name",
        "curLoginUsername": "Current Login User Name",
        "procInstCreatorName": "Process Initiator Name",
        "currentParticipantId": "Current Participant ID",
        "currentParticipantName": "Current Participant Name",
        "currentUser": "Current Login User",
        "preActExecutors": "Executors of the Previous Activity",
        "collectionElementVariable": "MultiInstance Child activity element variables",
        "subCollectionElementVariable": "MultiInstance Sub-process element variables",
        "nrOfInstances": "Total number of multiple instances",
        "nrOfCompletedInstances": "Number of multi-instance completed",
        "nrOfActiveInstances": "The number of multiple instances running",
        "nrOfForward": "Number of Passed Instances",
        "nrOfBackward": "Number of rejected instances",
        "nrOfAbort": "Number of terminated instances",
        "conclusionType": "Conclusion Type",
        "conclusionValue": "Conclusion Value",
        "directSuperior": "Direct Superior",
        "higherSuperior": "Indirect Superior",
        "DIRECT": "Direct",
        "EXTERNAL_PROCESS": "External Process",
        "SUB_PROCESS": "Subprocess",
        "ALL": "PC and Mobile",
        "WEB": "PC",
        "APP": "Mobile",
        "conclusionTypeTips": "The direction of item circulation, 1 for forward, 2 for backward, 3 for termination",
        "conclusionValueTips": "Item number, for example, 'Pass', 'Back', 'Refuse'",
        "copy": "_Copy",
        "saveAs": "Save As",
        "tips": "System Tips",
        "saveAsSuccess": "Save As Successful",
        "saveAsFail": "Save As Failed, please check if the process is correct!",
        "syncDt": "Whether to synchronize the current version of the process definition to the design-time process definition package",
        "checkExpressionAfterSaveAs": "Model validation failed, please check and modify the expression configuration in the process",
        "clickOk": "ClickOk",
        "ignoreAndContinue": "Ignore and continue",
        "processCategoryNotFound": "Please recheck the process, no process classification information found",
        "syncSuccess": "Synchronization Successful",
        "beforeCompleteStrategyChange": "There are running activity instances in the current node, adjusting the completion strategy is not allowed, please be aware!",
        "releaseProcess": "Review before Release",
        "auto": "Auto-generated Form",
        "push": "Push-generated Form",
        "pull": "Pull-generated Form",
        "creation": "Generate the target form through the form generation process"
      }
    },
    "multiInstanceLoopCharacteristics": {
      "loopCharacteristics": "Multi-instance Setup",
      "set": "(Set)",
      "notSet": "(Not Set)",
      "isEnable": "Enable",
      "isSequential": "Sequential",
      "loopCardinality": "Elements Collections",
      "completionConditionRules": "Completion COnditions",
      "promptAct1": "1. The number of elements in [Collection] is the number of instances of the sub-activity start.",
      "promptAct2": "2. When the sub-activity starts, the system will split and map the elements in the [Collection] to the [Element Variables] of each sub-activity instance.",
      "promptProc1": "1. The number of elements in [Collection] is the number of instances of the sub-process start.",
      "promptProc2": "2. When the sub-process starts, the system will split and map the elements in the [Collection] to the [Element Variables] of each sub-process instance.",
      "checkPrompt": "There are running activity instances in the current node, adjusting is not allowed",
      "completeSave": "Please configure the completion conditions and click confirm to save",
      "elementNotEmpty": "Element collection cannot be empty",
      "conditionRulesSet": "(Set)",
      "conditionRulesUnSet": "(Not Set)",
      "enableForbid": "After enabling multiple instances, it is not allowed to enable the multi instance setting when the return setting in the rejection rule is set to [Return to me] or when [Allow modification of return setting] is checked",
      "completionConditionRulesList": {
        "forward": "Forward",
        "backward": "BackWard",
        "abort": "Abort"
      }
    },
    "component": {
      "optins": {
        "wfOptions": "Workflow Options",
        "specified": "Specified Subprocess",
        "dynamic": "Dynamic Subprocess",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "subProcessType": "Subprocess Type",
        "processType": "Process Type",
        "bizDef": "Process Category",
        "procDef": "Process Definition",
        "clickCancel": "Cancel",
        "clickOk": "OK"
      },
      "voConfig": {
        "documentInfo": "Document Information",
        "viewModelSelection": "View Model Selection",
        "cancel": "Cancel",
        "clickOk": "OK",
        "selectOne": "Select One",
        "documentTypeSelect": "Document Type Selection",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "viewModel": "View Model",
        "documenttype": "Document Type",
        "placeholder": "Please Select"
      },
      "variableSetting": {
        "constant": "Constant",
        "expression": "Expression",
        "component": "Component",
        "ACTIVITY_STARTED": "Activity Started",
        "ACTIVITY_COMPLETED": "Activity Completed",
        "varAssign": "Variable Assignment",
        "varNumber": "Variable Number",
        "REQUIRED": "Required",
        "varName": "Variable Name",
        "valueType": "Value Type",
        "executionTime": "Execution Time",
        "valueText": "Variable Value",
        "processVariables": "Process Variables",
        "notSelectedVar": "Variable Not Selected!",
        "valueCannotEmpty": "Variable Value Cannot be Empty!",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "add": "Add",
        "delete": "Delete",
        "serialNumber": "Serial Number",
        "clickCancel": "Cancel",
        "clickOK": "OK",
        "inconsistentParameters": "Inconsistent Method Parameters for the Current Component, Please Update!",
        "methodNotExist": "The Current Component No Longer Exists This Method, Please Update!",
        "parameterName": "Parameter Name",
        "parameterValue": "Parameter Value",
        "methodnotSelected": "Component Method Not Selected Yet",
        "metadataNotExist": "Help Metadata Does Not Exist, Please Contact the System Administrator for Details!",
        "errorObtainComponent": "Error Obtaining Parsed Component",
        "componentSelection": "Component Selection",
        "componentName": "Component Name",
        "parameterList": "Parameter List",
        "lineNumber": "No."
      },
      "urgeHandleRule": {
        "urgentApproval": "Urge Approval:",
        "pleaseApprove": "Please Approve",
        "soOn": " ",
        "urgeHandle": "Urge Handle",
        "noSendingMethod": "No Sending Method Selected Yet!",
        "setMessageTemplate": "Message Template Needs to be Set When Using SMS as the Message Channel",
        "codeEmpty": "SMS Template Number Cannot be Empty",
        "noMessageSubject": "No Message Subject Configured Yet!",
        "noMessageContent": "No Message Content Selected Yet!",
        "earliestTimeNotEmpty": "Earliest Urge Time Cannot be Empty",
        "minimumTimeNotEmpty": "Minimum Urge Interval Cannot be Empty",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "enableUrgeHandle": "Enable Urgent Handling",
        "timeSetting": "Time Setting",
        "earliestTime": "Earliest Urge Time (Hours)",
        "minimumInterval": "Minimum Urge Interval (Hours)",
        "sendingMethod": "Sending Method",
        "messageSubject": "Message Subject",
        "supportEditing": "Support Editing",
        "messageContent": "Message Content",
        "displayReminder": "Display Urgent Reminder",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "titleExpression": {
        "zh-CHS": "Simplified Chinese",
        "zh-CHT": "Traditional Chinese",
        "en": "English",
        "taskDescription": "Task Description",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "currentLanguage": "Current Summary Language:",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "timeLimitControl": {
        "timedOutOperation": "Timed Out Operation",
        "constant": "Constant",
        "scope": "Time Scope",
        "day": "Day(s)",
        "hour": "Hour(s)",
        "minute": "Minute(s)",
        "BeforeDuration": "Before Due",
        "OnDuration": "On Due",
        "AfterDuration": "After Due",
        "SendMessageExpireOperation": "Expiring Alert",
        "AutoHandleExpireOperation": "Automatic Processing",
        "curDay": "Current Day",
        "durationType": "Duration Type",
        "required": "Required",
        "timeDuration": "Duration",
        "timeUnit": "Unit",
        "operationTypeName": "Operation Type Name",
        "sendType": "Operation",
        "onlyBeInteger": "Task Duration Can Only Be an Integer!",
        "setOperation": "Please Set Timeout Operation!",
        "setType": "Please Set Automatic Processing Type!",
        "setComments": "Please Set Automatic Processing Opinion!",
        "selectedOperation": "No Expiring Operation Selected Yet!",
        "notSupportAutomatic": "If the Next Node is Assigned by the Current Operator, the Current Node Does Not Support Automatic Task Processing",
        "warningMessage": "Warning Message",
        "automaticProcessing": "Automatic Processing",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "timelinessControl": "Task Processing Timeliness Control",
        "isEnable": "Enable or Not",
        "taskDeadline": "Task Deadline",
        "timelyOperation": "Timely Alert Operation",
        "actionList": "Action List",
        "add": "Add",
        "remove": "Remove",
        "clickCancel": "Cancel",
        "clickOK": "OK",
        "workItemParticipant": "Current Node Operator",
        "procInstCreator": "Process Initiator",
        "to-doMessageTimeOut": "You Have a Pending Task Message About to Time Out.",
        "messageTimeOut": "You Have a Message About to Time Out",
        "agree": "Agree"
      },
      "sendMessageOperation": {
        "procInstCreator": "Process Initiator",
        "workItemParticipant": "Current Node Handler",
        "preActExecutors": "Previous Node Handlers",
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "cycleTimeNotEmpty": "Cycle time interval cannot be empty!",
        "sendMethodNotEmpty": "Send method cannot be empty!",
        "subjectNotEmpty": "Message subject cannot be empty!",
        "contentNotEmpty": "Message content cannot be empty!",
        "recipientNotEmpty": "Recipient cannot be empty!",
        "messageTemplate": "Message template needs to be set when SMS channel is enabled",
        "smsTemplateNumberNotEmpty": "SMS template number cannot be empty",
        "cycleEnable": "Enable cycle warning",
        "cycleTime": "Cycle time interval",
        "sendType": "Send method",
        "subject": "Message subject",
        "message": "Message content",
        "receiverVari": "Recipient",
        "sysUsers": "System users",
        "clickCancel": "Cancel",
        "clickOK": "OK",
        "opinionsNotEmpty": "Automatic handling opinion cannot be empty!",
        "processingNotEmpty": "Automatic handling cannot be empty!",
        "automaticProcessSet": "Automatic handling settings",
        "automaticProcessMethod": "Automatic handling method",
        "automaticOpinionHandle": "Automatic handling opinion"
      },
      "smsMessageTemplate": {
        "smsTemplateContent": "Template text defined in third-party SMS service provider, for example: Your GS Cloud data platform account has been activated. Username: ${username}, initial password: ${code}. Please log in to the system in time.",
        "code": "Variable",
        "value": "Value",
        "noRowsSelected": "No rows selected",
        "smsMessageTemplate": "SMS Service Template",
        "tips1": "Message template refers to the association of template variables defined by third-party SMS service provider with GS Cloud variables after the template has been defined.",
        "tips2": "Template number defined in the third-party SMS service provider, for example: Aliyun SMS_220626324",
        "tips3": "Configure the association between variables in the third-party SMS service provider's template and variables in GSCloud",
        "smsTemplateNumber": "SMS template number",
        "smsVariableBinding": "SMS variable binding",
        "addSmsVariable": "Add",
        "deleteSmsVariable": "Delete"
      },
      "signRule": {
        "countersignRules": "Countersign rules",
        "byNumber": "By Quantity",
        "byProportion": "By Percentage (%)",
        "customConditions": "Custom Conditions",
        "value": "Number",
        "text": "Name",
        "conclusionName": "Conclusion Name",
        "conclusionValue": "Conclusion Value",
        "calculateType": "Calculation Method",
        "conditionValue": "Condition Value",
        "waitAllVotes": "Wait for all members to complete",
        "yes": "Yes",
        "no": "No",
        "notEmpty": "When the completion strategy is countersignature, the countersign rules cannot be empty. Please understand!",
        "conditionNotEmpty": "When the Calculation Method is set to Custom Conditions, the Custom Conditions cannot be empty!",
        "pleaseSelect": "Please select an item first!",
        "maxConditionValue": "The maximum value of the condition must be 100",
        "minConditionValue": "The minimum value of the condition must be 0",
        "noConditional": "No conditional value is required when the execution mode is unanimous or one vote",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "ruleList": "Rule List",
        "approvalOptions": "Approval Options",
        "clickCancel": "Cancel",
        "deleteRow": "Reset",
        "clickOK": "OK"
      },
      "saveAsEdit": {
        "public": "Public",
        "private": "Private",
        "code": "Number",
        "name": "Name",
        "nameNotEmpty": "Process name cannot be empty",
        "organizationNotEmpty": "Maintenance organization cannot be empty",
        "organization": "Organization",
        "basicAttributes": "Basic Attributes",
        "processName": "Process name",
        "processKeyValue": "Process Key value",
        "thisDocument": "This document",
        "otherDocument": "Other document",
        "entryFormEmpty": "Process Category has not been selected. Please select a process category or switch the save location to this document!",
        "entryForm": "Process Category",
        "savePos": "Save location",
        "maintenanceOrg": "Maintenance organization",
        "accessLevel": "Access level",
        "saveAsCancel": "Cancel",
        "saveAsOK": "OK"
      },
      "release": {
        "release": "Process Release",
        "update": "Process Update",
        "applicantName": "Applicant Name",
        "applicantDepartment": "Applicant Department",
        "procName": "Process name",
        "procVersion": "Process version",
        "releaseType": "Release type",
        "textDetail": "Description",
        "saveAsCancel": "Cancel",
        "saveAsOK": "OK"
      },
      "processVariables": {
        "string": "String",
        "integer": "Integer",
        "decimal": "Decimal",
        "boolean": "Boolean",
        "constant": "Constant",
        "expression": "Expression",
        "component": "Component",
        "name": "Variable number",
        "required": "Required",
        "documentation": "Variable name",
        "basicType": "Variable type",
        "description": "Description",
        "tag": "Initial value type",
        "valueText": "Initial value",
        "processVariables": "Process variables",
        "notSelected": "No process variables selected!",
        "variableNumberEmpty": "Variable number cannot be empty!",
        "variableNameEmpty": "Variable name cannot be empty!",
        "variableNumberNotStandard": "Variable number can only contain letters, numbers, and underscores, and cannot start with a number!",
        "tagNotEmpty": "Initial value type cannot be empty!",
        "codeDuplicates": "Process variable number cannot be duplicated!",
        "alreadyExists": "The added variable already exists!",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "add": "Add",
        "delete": "Delete",
        "number": "Number",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "participant": {
        "user": "User",
        "variable": "Variable Participant",
        "position": "Position",
        "role": "Role",
        "component": "Component Participant",
        "reportingLine": "Reporting Line",
        "matrix": "Matrix",
        "activityExecutor": "Historical Activity Executor",
        "organization": "Organization/Department",
        "all": "All",
        "assign": "Assign",
        "claim": "Claim",
        "currentUser": "Current Handler",
        "procInstCreator": "Process Initiator",
        "participantSet": "Participant Set",
        "order": "Order",
        "type": "Type",
        "performerName": "Name",
        "description": "Description",
        "condition": "Enable Condition",
        "dataMovement1": "Move default handler data to alternative handlers?",
        "dataMovement2": "Move alternative handler data to default handler?",
        "participantSelection": "Participant Selection",
        "selectProcessVariables": "Process variables not selected yet!",
        "selectVariableValueType": "Variable value type not selected yet!",
        "selectRelation": "Relation not selected yet!",
        "selectPosition": "Position not selected yet!",
        "selectOrgType": "Organization type not selected yet!",
        "orgFill": "Organization not filled yet!",
        "refOrgIdNotNull": "When reference type is organization, the reference organization field cannot be empty",
        "refUserIdNotNull": "When reference type is system user/employee, the reference person field cannot be empty",
        "repDefConfigured": "The reporting line has already been configured",
        "atLeastOneCondition": "At least one condition field must exist",
        "dataFieldAliasNotNull": "Data field cannot be empty",
        "matrixConfigured": "The matrix has already been configured",
        "selectPerformer": "Performer not selected yet",
        "definitionDeleted": "The definition of this reporting line data has been deleted, this data will be deleted",
        "matrixDeleted": "The definition of this matrix data has been deleted, this data will be deleted",
        "selectParticipantInfo": "Please select a participant information first!",
        "noRowSelected": "No row selected yet!",
        "selectDefaultHandler": "Please select a default handler first",
        "selectpotentialtHandler": "Please select an alternative handler first",
        "org": "Organization:",
        "positionType1": "Position type: General position, Organization:",
        "positionType2": "Position type: General position",
        "positionType3": "Position type: Organization position",
        "comp": "Component:",
        "parameters:": ", Parameters: {",
        "referencePerson:": "Reference person: ",
        "referenceOrganization:": "Reference organization: ",
        "code": "Code：",
        "condition1": "Condition 1: ",
        "condition2": "Condition 2: ",
        "condition3": "Condition 3: ",
        "data": "Data: ",
        "set": "(Set)",
        "notSet": "(Not set)",
        "allocationPolicy": "Allocation Policy",
        "operator": "Assign Operator",
        "multiSelect": "Allow Multiple Selection",
        "necessary": "Only one candidate user, still requires manual selection",
        "notifyRecipient": "Notify Recipient",
        "defaultHandler": "Default Handler",
        "new": "Add",
        "editPerformer": "Edit",
        "removePerformer": "Remove",
        "clearPerformer": "Clear",
        "moveUp": "Move Up",
        "moveDown": "Move Down",
        "alternativeHandler": "Alternative Handler",
        "isAllScope": "When specifying participants, there is no restriction, select from all users",
        "clickCancel": "Cancel",
        "clickOK": "OK",
        "alternativeScope": "Alternative Scope",
        "orgId": "OrgID",
        "includeChildren": "Include Children",
        "conditon": "Conditon",
        "currentUnit": "Current Unit",
        "currentDepartment": "Current Department",
        "variableOrganization": "Variable Org"
        // "assignOrganization": "Assign Org"
      },
      "activityExecutor": {
        "name": "Name",
        "eventHandler": ">Activity Executor",
        "nodeName": "Node Name",
        "enablingConditions": "Enable Conditions",
        "activityList": "Activity List",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "componentPerformer": {
        "componentMethod": "Current component method parameters are inconsistent, please update!",
        "methodNotExist": "This method does not exist in the current component, please update!",
        "code": "Code",
        "name": "Name",
        "description": "Description",
        "valueText": "Parameter Value",
        "help": "Help",
        "errorObtaining": "Error obtaining parsing component",
        "componentSelection": "Component Selection",
        "metadataNotExist": "Help metadata does not exist!",
        "serverSideNotFound": "Server side did not find help metadata, please check if the metadata has been deployed to the environment",
        "componentName": "Component Name",
        "componentSelect": "Component Selection",
        "parameterList": "Parameter List"
      },
      "matrixPerformer": {
        "code": "Code",
        "name": "Name",
        "help": "Help",
        "multivalue": "Multi",
        "enumSelection": "Enum Selection",
        "refMatrixTable": "Reference Matrix Table",
        "matrixTable": "Matrix Table",
        "curDataFieldValue": "Result Column",
        "conditionFields": "Condition Fields",
        "condition": "Enable Condition",
        "key": "Key",
        "value": "Value",
        "notSelectEnum": "Enum value not selected yet",
        "cancel": "Cancel",
        "onConfirm": "Confirm",
        "lineNumber": "Line Number"
      },
      "performerOptions": {
        "leave": "Flow Down",
        "throwException": "Exception Prompt",
        "sys": "User ID",
        "administrative_staff": "Employee ID",
        "procInstCreator": "Process Initiator",
        "preActExecutors": "Previous Node Executors",
        "allPassExecutors": "All Approved Personnel",
        "performerOptions": "Performer Options",
        "exclusionNotAllowed": "All Approved Personnel have set automatic approval, previous node executors are not allowed to be excluded by default!",
        "approvalNotAllowed": "When [Allocation Policy] is [Claim], automatic approval is not allowed to be set, please be aware!",
        "approvalNotAllowedAsSet": "All Approved Personnel have set not allowed for approval, previous node executors are not allowed to be automatically approved by default!",
        "allocationStrategyIsCollect": "When [Allocation Policy] is [Claim], automatic approval is not allowed to be set, please be aware!",
        "set": "(Set)",
        "advancedOptions": "Advanced Performer Options",
        "historicFirst": "When entering the node again, the handler is the previously handled personnel of the node",
        "noPerformerStrategy": "Handler is Empty Strategy:",
        "excludeProcInstCreator": "Exclude Handler Options",
        "defaultNotParticipate": "Process Initiator does not participate in approval by default",
        "excludePreActExecutors": "Previous node executors do not participate in approval by default",
        "excludeAllPassExecutors": "All Approved Personnel do not participate in approval by default",
        "excludeExprPerformer": "Process Variable:",
        "variableOrgTypes": "Variable Value Types:",
        "automaticApprovalOptions": "Automatic Approval Options",
        "autoProcInstCreator": "Process Initiator is automatically approved by default",
        "autoPreActExecutors": "Previous node executors are automatically approved by default",
        "autoAllPassExecutors": "All Approved Personnel are automatically approved by default",
        "cancel": "Cancel",
        "clickOK": "OK"
      },
      "positionPerformer": {
        "orgPosition": "Organization Position",
        "generalPosition": "General Position",
        "sysPositions": "System Positions",
        "positionType": "Position Type",
        "role": "Role",
        "position": "Position",
        "sysType": "Organization Type",
        "placeholder": "Please select",
        "orgId": "Organization ID",
        "condition": "Enable Condition",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "reportingLine": {
        "higherSuperior": "Indirect Supervisor",
        "directSuperior": "Direct Supervisor",
        "code": "Code",
        "name": "Name",
        "dept": "Organization",
        "sysUser": "System User",
        "employee": "Employee",
        "businessFields": "Business Fields",
        "defName": "Reporting Definition",
        "dimension": "Reporting Level",
        "curReportingRefer": "Reference Type",
        "usersName": "Reference Person",
        "refOrgId": "Reference Organization",
        "condition": "Enable Condition",
        "definitionOfReport": "Definition of Reporting Relationship"
      },
      "userPerformer": {
        "regularUser": "Regular User",
        "variablePart": "Variable Participant",
        "sys": "System User",
        "administrative_organization": "Employee",
        "cantUseContext": "Administrative staff type cannot use this context variable",
        "user": "User",
        "variable": "Variable",
        "condition": "Enable Condition"
      },
      "variablePerformer": {
        "sys": "User ID",
        "administrative_staff": "Employee ID",
        "oneself": "Self",
        "administrative_organization": "Department ID",
        "cantUseContext": "Administrative staff type cannot use this context variable",
        "processVariables": "Process Variables",
        "variableOrgTypes": "Variable Value Types",
        "relationShipType": "Relationship",
        "condition": "Enable Condition",
      },
      "orgPotentialOwner": {
        "optionSettings": "Option Settings",
        "global": "All Members",
        "currentUnit": "Current Unit",
        "currentDepartment": "Current Department",
        "addSignBehind": "Add Signature",
        "addSignFront": "Consult",
        "transfer": "Transfer",
        "notify": "Notify",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "option": "Option",
        "enable": "Enable or Not",
        "range": "Range",
        "OrgId": "Org Id",
        "variableOrganization": "Variable Org",
        "includeChildren": "Include Subordinates",
        "clickCancel": "Cancel",
        "clickOK": "OK",
        "limit": "Limit Scope",
        "turnOffPrompt": "Please Turn off the Scope of People option!"
      },
      "note": {
        "placeholder": "Please enter process change record",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "MessageNotice": {
        "notify": "Message Notice",
        "subject": "Message Subject",
        "content": "Message Content",
        "sendTime": "Sending Time",
        "sendType": "Send Method",
        "receiverText": "Message Receiver",
        "procInstCreator": "Process Initiator,",
        "workItemParticipant": "Task Receiver,",
        "messageSet": "Message Settings",
        "selectedRow": "No message notification selected yet!",
        "noCopy": "No message notification attributes to copy!",
        "batchCopy": "Batch Copy",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "add": "Add",
        "edit": "Edit",
        "delete": "Delete",
        "lineNumber": "Number",
        "clickCancel": "Cancel",
        "clickOK": "OK",
        "messContent": { "expr": "\'You have a message notification.\'", "sexpr": "" },
        "procComplete": "Process Completed",
        "procAborted": "Process Aborted",
        "procRollBack": "Process Rejected",
        "workCreated": "Task Created",
        "workAborted": "Task Aborted",
        "actComplete": "Activity Completed",
        "actAborted": "Activity Aborted",
        "email": "Email",
        "sms": "SMS",
        "cloudplus": "Cloud",
        "processParticipant": "Process Participant",
        "variableParticipant": "Variable Participant",
        "userParticipant": "Designated User",
        "positionParticipant": "Position",
        "activityExecutorParticipant": "Historical Handler",
        "sys": "System User",
        "administrative_organization": "Employee",
        "name": "Name",
        "noTargetNode": "No node selected yet!",
        "noMessageNotifyAttribute!": "No message notification attribute!"
      },
      "messageNoticeEdit": {
        "procInstCreator": "Process Initiator",
        "activityExecutorParticipant": "Historical Handler",
        "workItemParticipant": "Task Handler",
        "sys": "System User",
        "administrative_organization": "Employee",
        "processParticipant": "Process Participant",
        "workItemReceiveParticipant": "Task Receiver",
        "variableParticipant": "Variable Participant",
        "userParticipant": "Designated User",
        "positionParticipant": "Position",
        "sendType": "Send method cannot be empty",
        "smsMessageTemplate": "Message channel requires SMS, please set the message template",
        "smsMessageTemplateCode": "SMS template code cannot be empty",
        "sendTime": "Sending time cannot be empty",
        "subject": "Message subject cannot be empty",
        "content": "Message content cannot be empty",
        "receivers": "Receiver cannot be empty!",
        "processParticipantNotNull": "Process participant cannot be empty",
        "activityDefIdNotNull": "When process participant is historical handler, the handling node cannot be empty",
        "variableParticipantNotNull": "Variable participant cannot be empty",
        "orgType": "Organization type of variable participant cannot be empty",
        "userIds": "Designated user cannot be empty",
        "positionId": "Position cannot be empty",
        "activityList": "Activity List",
        "position": "Position",
        "optionalNodes": "Optional Nodes",
        "targetNodeList": "Target Node List",
        "placeholder": "Please select target node",
        "optionalAttribute": "Optional Attributes",
        "lineNumber": "Number",
        "clickCancel": "Cancel",
        "clickOK": "OK",
        "messSendType": "Message Channel",
        "messSubject": "Message Subject",
        "enable": "Enable Expression",
        "messContent": "Message Content",
        "recipient": "Receiver",
        "addReceiver": "Add",
        "organization": "Organization:",
        "posi": "Position:"
      },
      "jumpScope": {
        "targetNodeOptions": "Target Node Options",
        "name": "Name",
        "outConnectNode": "Process Diagram Connection Node",
        "global": "All Nodes within the Process",
        "afterNodes": "All Successor Nodes",
        "specifiedSet": "Process Diagram Connection Node + Additional Nodes",
        "firstNode": "Conditional true connection node, when there are multiple options, the first one is selected by default",
        "nullNode": "Default is empty, manual selection every time",
        "specifyNode": "Specify the default node",
        "noSetTargetNode": "Target node options not set yet, please understand!",
        "noSetSpecifyNode": "Default node not specified yet, please understand!",
        "selectedRow": "Please select an option first!",
        "optionalNodes": "Optional Nodes",
        "listOfAdditional": "List of Additional Nodes",
        "pleaseSelect1": "Please select additional nodes",
        "defaultNode": "Default Node",
        "pleaseSelect2": "Please select default node",
        "defaultNodeList": "Default Node List",
        "clickCancel": "Cancel",
        "clickOK": "OK",
        "set": "(Set)"
      },
      "imageSet": {
        "imageSet": "Image Setting",
        "onlyView": "View Only",
        "edit": "Edit",
        "reScanStart": "Initiate Re-scan",
        "reScanComplete": "Re-scan Complete",
        "mutualExclusion": "[View Only] option is exclusive with other options, please understand!",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "imageOperation": "Image Operation Permission",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "extendProperty": {
        "extendProperty": "Extended Property",
        "true": "Yes",
        "false": "No",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "illustrate": "Illustrate",
        "placeholder": "Please select",
        "cancel": "Cancel",
        "clickOK": "OK"
      },
      "expressionEditor": {
        "expressionEditor": "Expression Editor",
        "notSet": "(Not Set)",
        "clickCancel": "Cancel",
        "changeType": "Switch Type",
        "clickOK": "OK"
      },
      "executeForms": {
        "executeForms": "Form Definition",
        "parameters": "Parameters [",
        "typeAsvariable": "] is of variable type, but does not exist in process variables",
        "parameterSettings": "Parameter Settings",
        "formDefinitionList": "Form Definition List",
        "notSet": "(Not Set)",
        "default": "Process Default Form",
        "processEmbeddedForm": "Process-Embedded Form",
        "formEmbedProcess": "Form-Embedded Process",
        "clickCancel": "Cancel",
        "clickOK": "OK",
        "noForm": "No Form Format",
        "form": "Select Form",
        "placeholder": "Please select",
        "parametersSet": "Parameters",
        "key": "Variable ID",
        "name": "Variable Name",
        "lineNumber": "Serial Number",
        "code": "Code",
        "paramName": "Name",
        "tag": "Type",
        "value": "Parameter Value",
        "variable": "Variable",
        "constant": "Constant",
        "expression": "Expression",
        "method": "Method Identifier",
        "methodName": "Method Name",
        "description": "Description",
        "workFlowAction": "Workflow Direction",
        "formOperations": "Form Operations",
        "executionTime": "Execution Time",
        "sortOrder": "Execution Order",
        "methodParameters": "Parameters",
        "selectFormActionConfig": "Form Action Configuration not selected!",
        "selectFormAction": "Form Action not selected!",
        "editParam": "Settings",
        "formEvents": "Form Events",
        "buttonName": "Button Name",
        "enable": "Enabled",
        "disabled": "Disabled",
        "hidden": "Hidden",
        "fieldName": "Field Name",
        "editable": "Editable",
        "readonly": "Read-only",
        "required": "Required",
        "saveFail": "Failed to save configuration. Please contact the administrator for details!",
        "checkedRows": "No button collection selected",
        "checkeds": "No field collection selected",
        "enableBtn": "Enabled",
        "disabledBtn": "Disabled",
        "hiddenBtn": "Hidden",
        "btnBatchReset": "Reset",
        "editableBtn": "Editable",
        "readonlyBtn": "Read-only",
        "requiredBtn": "Required",
        "add": "Add",
        "delete": "Delete",
        "other": "Other",
        "formBtn": "Form Button",
        "formfield": "Form Field",
        "apptag": "Document Type",
        "functionMenu": "Function Menu",
        "formFormat": "Form Format",
        "docFormatNumber": "Document Format Number",
        "docFormatName": "Document Format Name",
        "selectedRow": "No form definition selected!",
        "set": "(Set)",
        "operationDelete": "This operation does not allow deletion",
        "operationAdd": "This operation cannot be added",
        "alreadySelect": "The form definition has been selected, please choose another form",
        "canAddSameOperation": "Form operations do not allow duplicates"
      },
      "eventDefinition": {
        "eventDefinition": "Signal Definition",
        "pass": "Forward",
        "back": "Backward",
        "abort": "Abort",
        "signalRef": "Signal ID",
        "name": "Signal Name",
        "triggerAction": "Workflow Direction",
        "selectedRow": "No trigger event selected!",
        "dataLength": "At least one signal definition is required!",
        "codeNotNull": "Signal ID cannot be empty!",
        "nameNotNull": "Signal Name cannot be empty!",
        "codeNotNumber": "Signal ID cannot be pure numbers!",
        "codeRepeat": "Signal ID cannot be repeated!",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "add": "Add",
        "delete": "Delete",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "entryFormEditor": {
        "flowForm": "Process Category",
        "code": "Code",
        "name": "Name",
        "base": "Base",
        "foundation": "Foundation",
        "extend": "Extended",
        "selectedRow": "No process category selected",
        "absent": "Process category no longer exists",
        "lineNumber": "Serial Number",
        "clickCancel": "Cancel",
        "clickOK": "Rebind"
      },
      "editComponentParameter": {
        "code": "Code",
        "name": "Name",
        "required": "Required",
        "yes": "Yes",
        "no": "No",
        "value": "Parameter Value",
        "openComponentFail": "Failed to parse component",
        "componentSelection": "Component Selection",
        "curComponent": "Please select a process component",
        "executionTime": "Please select execution time",
        "para": "Parameter",
        "paraRequired": "] is required",
        "execuTime": "Execution Time",
        "parameterList": "Parameter List",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "customizeAction": {
        "customizeAction": "Customize Action",
        "app": "Mobile",
        "web": "Web",
        "all": "Web, Mobile",
        "name": "Name",
        "code": "Code",
        "terminalType": "Terminal Type",
        "isAll": "Default",
        "yes": "Yes",
        "no": "No",
        "paramName": "Code",
        "valueText": "Name",
        "value": "Parameter Value",
        "addActions": "Select Custom Actions",
        "actionExisted": "The added custom action already exists!",
        "selectedRow": "Please select an option first!",
        "set": "(Set)",
        "notSet": "(Not set)",
        "add": "Add",
        "delete": "Delete",
        "parameterList": "Parameter List",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "checkCondition": {
        "zhChs": "Simplified Chinese",
        "zhCht": "Traditional Chinese",
        "en": "English",
        "checkCondition": "Activity Validation Rule",
        "set": "(Set)",
        "notSet": "(Not set)",
        "nodeEntry": "Node Entry",
        "activityBeforeStarted": "Node Entry Condition",
        "enterErrorTips": "Enter Condition Mismatch Tips",
        "activityBeforeCompleted": "Node Exit",
        "activityBeforeCompletedValue": "Node Exit Condition",
        "leaveErrorTips": "Leave Condition Mismatch Tips",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "batchSet": {
        "targetNode": "target Node",
        "addSignFront": "addSign Front",
        "addSignBehind": "addSign Behind",
        "transfer": "transfer",
        "notify": "notify",
        "backWardRule": "backWard Rule",
        "participantOptions": "performer Options",
        "name": "name"
      },
      "subProcess": {
        "subProcessSet": "Subprocess Settings",
        "specified": "Specify Subprocess",
        "dynamic": "Dynamic Subprocess",
        "inheritParent": "Same as Parent Process",
        "autoCreation": "Auto Generate Downstream Documents",
        "variablesExpression": "Variable Expression",
        "rteNull": "Please select a document workflow",
        "orderProcess": "Document Workflow",
        "clickOk": "OK",
        "clickCancel": "Cancel",
        "inheritBizDataId": "When the subprocess is inconsistent with the parent process document, please set the subprocess document ID!",
        "set": "(Set)",
        "notSet": "(Not set)",
        "radioGroupProcessType": "Sub Type",
        "flowForm": "Flow Category",
        "processDef": "Process Definition",
        "radioGroupBillSource": "Source",
        "autoCreationProcess": "Auto Process",
        "bizDataId": "Document ID",
        "setOption": "Set options",
        "SameParentProcess": "The same business document as the parent process",
        "setBizDataId": "Set document ID",
        "subProcessOpt": "Subprocess Options"
      },
      "backwardRule": {
        "reEdit": "The rejected activity node no longer exists. Please re-edit.",
        "backwardRule": "Rejection Rule",
        "initialActityId": "Start Node",
        "precursorActivityId": "Predecessor Node",
        "empty": "Empty",
        "name": "Name",
        "id": "Identifier",
        "sequence": "Sequential Transition",
        "backToMe": "Return to Me",
        "backToCurrentNode": "Return to Current Node",
        "popover": "1. Sequential Transition: Transition according to the order of the flow lines; 2. Return to Me: If the completion strategy is Preemptive, only create tasks for the person who rejected it. If the completion strategy is Countersignature, the person who rejected it and the unapproved person will receive new tasks, and the approved personnel will automatically approve them; 3. Return to Current Node: The actual effect is affected by the option 'Is the executor a person who has already processed the node when entering the node again'",
        "selectAbleClick": "Under the Countersignature strategy, dynamic selection of rejection target nodes is not allowed!",
        "dictPicked": "Please use the 'Revert to Empty' option with the 'Allow dynamic selection of rejection target nodes' option",
        "set": "(Set)",
        "notSet": "(Not set)",
        "rejectedTo:": "Reverted to:",
        "backScope": "Scope of rejection",
        "defaultPrompt": "All historical rejection nodes are selected by default",
        "title": "Activity List",
        "dynamicSelection": "Allow dynamic selection of rejection target nodes",
        "resubmitEffectOptions": "Return Settings",
        "popover1": "1. Sequential Transition: Transition according to the order of the flow lines;",
        "popover2": "2. Return to Me: If the completion strategy is Preemptive, only create tasks for the person who rejected it. If the completion strategy is Countersignature, the person who rejected it and the unapproved person will receive new tasks, and the approved personnel will automatically approve them;",
        "popover3": "3. Return to Current Node: The actual effect is affected by the option 'Is the executor a person who has already processed the node when entering the node again'",
        "allowModification": "Allow modification of return settings",
        "dynamicBackWardRuleAbleClick": "After enabling multiple instances, it is forbidden to check the option to allow modification of return settings",
        "backToMeForbid": "After enabling multiple instances, it is prohibited to select 'return to me'",
        "clickCancel": "Cancel",
        "clickOk": "OK"
      },
      "assignStrategy": {
        "all": "All",
        "assign": "Assign",
        "claim": "Claim",
        "currentUser": "Current Executor",
        "procInstCreator": "Process Initiator",
        "assignStrategy": "Assignment Strategy",
        "option": "Option",
        "assignmentRules": "Assignment Rules",
        "operator": "Assign Operator",
        "multiSelect": "Multiple candidate users can be selected",
        "necessary": "Only one candidate user, still requires manual selection",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "assignScope": {
        "assignScopeList": "Assigned Node List",
        "required": "Required",
        "yes": "Yes",
        "no": "No",
        "condition": "Condition",
        "add": "Add",
        "delete": "Delete",
        "name": "Name",
        "deleteRow": "Please select an option first!",
        "curActivity": "No row selected",
        "duplicateNodeNoAdd": "Selected nodes will not be added repeatedly",
        "set": "(Set)",
        "notSet": "(Not set)",
        "nodeList": "Node List",
        "moveUp": "Move Up",
        "moveDown": "Move Down",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "assignPerformer": {
        "currentUser": "Current User",
        "procInstCreator": "Process Initiator",
        "global": "Global",
        "currentUnit": "Current Unit",
        "currentDepartment": "Current Department",
        "assignPerformer": "Assign Rule",
        "set": "(Set)",
        "operator": "Assign Operator",
        "multiSelect": "Allow Selecting Multiple Candidates",
        "necessary": "When there is only one candidate, manual selection is still required",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "approvelItems": {
        "approvalOptions": "Approval Options",
        "forward": "Forward",
        "backward": "Backward",
        "abort": "Abort",
        "value": "Number",
        "text": "Name",
        "workFlowAction": "Workflow Direction",
        "isDefault": "Default",
        "no": "No",
        "yes": "Yes",
        "commentNecessary": "Comment Required",
        "attachmentNecessary": "Attachment Upload",
        "certification": "Digital Signature",
        "signatureNecessary": "Manual Signature Required",
        "defaultComment": "Default Comment",
        "zh-CHS": "Simplified Chinese",
        "zh-CHT": "Traditional Chinese",
        "en": "English",
        "workFlowActionNotNull": "Approval item workflow direction cannot be empty, please modify!",
        "deleteRow": "Please select an option first!",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "add": "Add",
        "delete": "Delete",
        "clickCancel": "Cancel",
        "clickOK": "OK",
        "approvalAction": "Approval Action",
        "lineNumber": "Number"
      },
      "approvalPivot": {
        "remind": "Text Prompt",
        "type": "Type",
        "condition": "Condition",
        "title": "Display Name",
        "description": "Detailed Description",
        "approvalPivot": "Approval Key Point",
        "selectedRow": "Approval key point not selected!",
        "configTitle": "Display title not filled!",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "enable": "Enable",
        "expand": "Expand",
        "showTitle": "Display Title",
        "list": "List",
        "add": "Add",
        "delete": "Delete",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "anonymousSet": {
        "anonymousOpt": "Anonymous Option",
        "approver": "Approver",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "anonymousSet": "Anonymous Settings",
        "isAnonymity": "Enable",
        "anonymous": "Anonymous Alias",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "activityList": {
        "name": "Name",
        "checkeds": "No activity nodes selected",
        "lineNumber": "Number",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      },
      "activityComponent": {
        "component": "Component",
        "method": "Component Method",
        "inconsistentParameters": "Inconsistent parameters, please check",
        "longerExists": "The component no longer exists in this method",
        "absent": "Cancel",
        "pleaseCheck": ", please check",
        "edit": "Edit",
        "deleteRow": "Delete",
        "executionTime": "Execution Time",
        "cmpName": "Component Name",
        "metadataId": "Component ID",
        "methodCode": "Component Method",
        "isForCompensation": "Compensation Operation",
        "yes": "Yes",
        "no": "No",
        "operate": "Operate",
        "code": "Code",
        "name": "Name",
        "value": "Parameter Value",
        "editComponent": "Edit Component",
        "confirmDelete": "Confirm whether to delete the component?",
        "curComponent": "No component selected!",
        "newComponent": "New Component",
        "selectComponent": "Select Component",
        "sameCmp": "There are duplicate process components",
        "cmpMethod": "Component Method:",
        "executionTimeNotNull": "Component execution time cannot be empty!",
        "param": " parameter",
        "required": "Required",
        "set": "(Set)",
        "notSet": "(Not Set)",
        "PROCESSINSTANCE_STARTED": "Process Started",
        "PROCESSINSTANCE_SUSPENDED": "Process Suspended",
        "PROCESSINSTANCE_RESUMED": "Process Resumed",
        "PROCESSINSTANCE_COMPLETED": "Process Completed",
        "PROCESSINSTANCE_ABORTED": "Process Aborted",
        "PROCESSINSTANCE_CANCELED": "Process Canceled",
        "PROCESSINSTANCE_REACTIVATED": "Process Reactivated",
        "PROCESSINSTANCE_ROLLBACK": "Process Rolled Back",
        "PROCESSINSTANCE_RESUBMIT": "Resubmit Process",
        "ACTIVITY_AND_PARTICIPANT_UPDATED": "Activity Participants Changed",
        "PROCESSINSTANCE_ABORTED_BY_ADMIN": "Terminated by Administrator",
        "PROCESSINSTANCE_BEFORE_START": "Before Process Start",
        "WORKITEM_BEFORE_COMPLETE": "Before Task Completion",
        "WORKITEM_AFTER_COMPLETE": "After Task Completion",
        "LOADDATA": "Retrieve Data",
        "ACTIVITY_STARTED": "Activity Started",
        "ACTIVITY_COMPLETED": "Activity Completed",
        "ACTIVITY_ABORTED": "Activity Aborted",
        "WORKITEM_CREATED": "Work Item Created",
        "WORKITEM_COMPLETED": "Work Item Completed",
        "WORKITEM_SUSPENDED": "Work Item Suspended",
        "WORKITEM_RESUMED": "Work Item Resumed",
        "WORKITEM_ABORTED": "Work Item Aborted",
        "WORKITEM_RETRIEVED": "Work Item Retrieved",
        "WORKITEM_CLAIMED": "Work Item Claimed",
        "WORKITEM_UNCLAIMED": "Work Item Unclaimed",
        "ACTIVITY_ASSIGNMENT": "Task Assignment",
        "deleteNotAllowed": "The data retrieval component cannot be deleted, please understand!",
        "tips": "Tips:",
        "prefabricated": "External process components have been prefabricated, only data retrieval components are retained here",
        "add": "Add",
        "moveUp": "Move Up",
        "moveDown": "Move Down",
        "clickCancel": "Cancel",
        "clickOK": "OK"
      }
    }
  },
  "zh-CHT": {
    "validate": {
      "noProcessHeader": "模型不存在processHeader内容",
      "cmpsEmpty": "流程構件為空",
      "cmpsEmptyMsg": "流程構件不允許為空,請聯系表單開發確認問題",
      "directNoPf": "啟動管道為【直接】的流程不應該包含共亯（PF）的流程構件",
      "directNoPfMsg": "請移除以下共亯（PF）的流程構件:",
      "noLoadDataCmp": "缺少執行時機為[獲取數據]的流程構件",
      "noLoadDataCmpMsg": "流程定義不能缺少取數構件,請聯系表單開發確認問題",
      "noStartCmp": "缺少執行時機為[流程啟動]的流程構件",
      "noStartCmpMsg": "會導致流程啟動時無法修改單據狀態,請聯系表單開發確認問題",
      "lackProcessCompleteCmp": "缺少執行時機為[流程完成]的流程構件",
      "lackProcessCompleteCmpMsg": "會導致流程完成時無法修改單據狀態,請聯系表單開發確認問題",
      "lackProcessAbortCmp": "缺少執行時機為[流程終止]的流程構件",
      "lackProcessAbortCmpMsg": "會導致流程終止時無法修改單據狀態,請聯系表單開發確認問題",
      "lackProcessCancelCmp": "缺少執行時機為[流程終止]的流程構件",
      "lackProcessCancelCmpMsg": "會導致流程終止時無法修改單據狀態,請聯系表單開發確認問題",
      "lackProcessBackCmp": "缺少執行時機為[流程駁回]的流程構件",
      "lackProcessBackCmpMsg": "會導致流程駁回時無法修改單據狀態,請聯系表單開發確認問題",
      "lackProcessReStartCmp": "缺少執行時機為[重新提交]的流程構件",
      "lackProcessReStartCmpMsg": "會導致流程重新提交時無法修改單據狀態,請聯系表單開發確認問題",
      "parallelGatewayCheck": "【並行閘道】沒有成對出現",
      "parallelGatewayCheckMsg": "【並行閘道】需作為一條流程分支的折開節點和彙聚節點成對出現,請修改",
      "inclusiveGatewayCheck": "【包容網關】沒有成對出現",
      "inclusiveGatewayCheckMsg": "【包容網關】需作為一條流程分支的折開節點和彙聚節點成對出現,請修改",
      "approvalPerformerCheck": "活動,未設定參與者",
      "notifyPerformerCheck": "節點，未設定知會接收人",
      "noVariable1": "活動【變數設定】内容中已設定變數",
      "noVariable2": "在流程内容【流程變數】中已不存在,請修改！",
      "noSignRule": "節點未設定會簽規則",
      "activity": "活動【",
      "noStartActivity": "】的標識不合法,不是以[startActivity]開頭",
      "noExclusiveGateway": "】的標識不合法,不是以[ExclusiveGateway]開頭",
      "noParallelGateway": "】的標識不合法,不是以[ParallelGateway]開頭",
      "noUserActivity": "】的標識不合法,不是以[UserActivity]開頭",
      "noOperationActivity": "】的標識不合法,不是以[OperationActivity]開頭",
      "noNotifyActivity": "】的標識不合法,不是以[NotifyActivity]開頭",
      "noCallActivitySubProcess": "】的標識不合法,不是以[CallActivitySubProcess]開頭",
      "noAutoActivity": "】的標識不合法,不是以[AutoActivity]開頭",
      "noIntermediateCatchEvent": "】的標識不合法,不是以[IntermediateCatchEventImpl]開頭",
      "noMessageActivity": "】的標識不合法,不是以[MessageActivity]開頭",
      "noAifCreationBillActivity": "】的標識不合法,不是以[AifCreationBillActivity]開頭",
      "noEndEvent": "】的標識不合法,不是以[EndEvent]開頭",
      "mark": "標識為【",
      "noFlowNodeChsName": "】的活動簡體中文名稱為空，請修改",
      "nameExceedsLengthLimit": "】的名稱超長，不能超過40個字元，請修改"
    },
    "processEditor": {
      "tip": "提示",
      "showButton": "顯示查看模型按鈕",
      "changeRecord": "流程變更記錄",
      "noDtInfo": "不存在設計時流程信息！請先賦值！",
      "noRtInfo": "不存在運行時流程信息！請先賦值！",
      "wrongMoment": "設計者運行時機錯誤！",
      "prompted": "系統提示",
      "saveSuccess": "保存成功",
      "waitReview": "保存成功，等待發起審核",
      "successPublish": "發布成功",
      "publishFail": "發布失敗，",
      "policyConflict": "會簽策略下，“駁回規則”不允許“動態選擇駁回目標節點”，請修改！",
      "noPermissionToSave": "當前用戶不具備另存流程的權限",
      "closeProc1": "關閉此頁面？",
      "closeProc2": "系統可能不會保存您所做的更改。",
      "closeProc3": "系統可能不會保存另存為後的頁面或所作的修改",
      "viewModel": "查看模型",
      "copied": "模型已經復制到剪貼板",
      "releaseCheckPrompt": "當前流程為稽核狀態，需要等到稽核完成後，才可進行下一次發佈",
      "checkProcessCategoryExist": "請確認環境中是否存在該流程設計對應的流程分類",
      "processIsExist": "請確認當前流程定義是否被删除",
      "button": {
        "saveProc": "保存",
        "releaseProc": "發布",
        "sync": "同步設計時包",
        "saveAs": "另存為",
        "procRecord": "流程記錄",
        "viewProcModel": "查看模型",
        "closeProc": "關閉"
      }
    },
    "designer": {
      "wfEditorUi": {
        "basicElements": "基本元素",
        "readOnly": "只讀"
      },
      "wfProcessCell": {
        "basicInfo": "基本信息",
        "name": "名稱",
        "nameLanguage": "名稱",
        "key": "標識",
        "entryForm": "流程分類",
        "startMode": "啟動方式",
        "wfTitle": "流程摘要",
        "formDef": "表單定義",
        "formsPC": "PC表單",
        "formsMobile": "移動表單",
        "process": "事件監聽",
        "advanced": "高級屬性",
        "basic": "基礎屬性",
        "wfComponent": "流程構件",
        "otherConfig": "其他配置",
        "processVariables": "流程變量",
        "basicElements": "基本元素",
        "customizeAction": "自定義動作",
        "timelinessInfo": "時效信息",
        "enablePriority": "啟用緊急程度",
        "enableWholeOrderRetrieve": "撤回在審單據",
        "messageProperty": "影像設置",
        "timeLimitControl": "超時操作",
        "messageNotice": "消息通知",
        "extendProperty": "擴展屬性",
        "directTips": "提示：啟動方式切換為直接，直接啟動是默認的流程啟動方式，切換後會移除共享(PF)相關構件，請知悉！",
        "externalTips": "提示：啟動方式切換為外部流程，適用於作為共享流程的外部流程相關場景，切換後保留流程上的共享（PF)相關構件，請知悉！",
        "subprocessTips": "提示：啟動方式切換為子流程，適用於調用式子流程的場景，切換後會移除除取數構件外的其他流程構件，請知悉！"
      },
      "WfSequenceFlowEdge": {
        "basicInfo": "基本信息",
        "basic": "基礎屬性",
        "name": "名稱",
        "nameLanguage": "名稱",
        "id": "標識",
        "condition": "條件選項",
        "ConditionExpression": "條件",
        "default": "缺省轉移線"
      },
      "wfSidebar": {
        "bizactivitylib": "業務活動"
      }
    },
    "app": {
      "processDesigner": {
        "all": "所有",
        "assign": "指派",
        "claim": "領用",
        "preempt": "搶占模式",
        "parallel": "並行會簽",
        "sequential": "串行會簽",
        "true": "是",
        "false": "否",
        "dataId": "單據內碼",
        "procInstId": "流程實例ID",
        "bizDefKey": "入口單據ID",
        "processDefinitionKey": "流程定義KEY",
        "procInstCreator": "流程發起人",
        "businessCreator": "業務發起人",
        "procInstDescription": "流程摘要",
        "comment": "審批意見",
        "bizDefName": "流程分類名稱",
        "curLoginUsername": "當前登錄人名稱",
        "procInstCreatorName": "流程發起人名稱",
        "currentParticipantId": "當前辦理人ID",
        "currentParticipantName": "當前辦理人名稱",
        "currentUser": "當前登錄用戶",
        "preActExecutors": "上一個活動的執行人",
        "collectionElementVariable": "多實例子活動元素變數",
        "subCollectionElementVariable": "多實例子流程元素變數",
        "nrOfInstances": "多實例總數量",
        "nrOfCompletedInstances": "多實例已完成數量",
        "nrOfActiveInstances": "多實例正在運行中的數量",
        "nrOfForward": "通過實例數量",
        "nrOfBackward": "駁回實例數量",
        "nrOfAbort": "終止實例數量",
        "conclusionType": "結論類型",
        "conclusionValue": "結論值",
        "directSuperior": "直接上級",
        "higherSuperior": "間接上級",
        "DIRECT": "直接",
        "EXTERNAL_PROCESS": "外部流程",
        "SUB_PROCESS": "子流程",
        "ALL": "電腦端和移動端",
        "WEB": "電腦端",
        "APP": "移動端",
        "conclusionTypeTips": "審批項流轉方向，1正向，2反向，3終止",
        "conclusionValueTips": "審批項編號，例如，Pass、Back、Refuse",
        "copy": "_副本",
        "saveAs": "另存為",
        "tips": "系統提示",
        "saveAsSuccess": "另存為成功",
        "saveAsFail": "另存為失敗，請檢查流程是否正確！",
        "syncDt": "是否將當前版本流程定義同步到設計時流程定義包",
        "checkExpressionAfterSaveAs": "模型校驗失敗，請檢查並修改流程中的運算式配寘",
        "clickOk": "確認",
        "ignoreAndContinue": "忽略並繼續",
        "processCategoryNotFound": "請重新檢查流程，未找到流程分類資訊",
        "syncSuccess": "同步成功",
        "beforeCompleteStrategyChange": "當前節點存在運行中的活動實例，不允許調整完成策略，請了解！",
        "releaseProcess": "發布前審核",
        "auto": "自動生單",
        "push": "推式生單",
        "pull": "拉式生單",
        "creation": "通過生單流程生成目標單"
      }
    },
    "multiInstanceLoopCharacteristics": {
      "loopCharacteristics": "多實例設置",
      "set": "（已設置）",
      "notSet": "（未設置）",
      "isEnable": "是否啟用",
      "isSequential": "是否串行",
      "loopCardinality": "元素集合",
      "completionConditionRules": "完成條件",
      "promptAct1": "1、[集合]中的元素個數為子活動啟動實例數量。",
      "promptAct2": "2、子活動啟動時系統會將[集合]中的元素拆分映射到各個子活動實例的[元素變數]。",
      "promptProc1": "1、[集合]中的元素個數為子流程啟動實例數量。",
      "promptProc2": "2、子流程啟動時系統會將[集合]中的元素拆分映射到各個子流程實例的[元素變數]。",
      "checkPrompt": "當前節點存在運行中的活動實例，不允許調整",
      "completeSave": "請配寘完成條件，並點確認進行保存",
      "elementNotEmpty": "元素集合不允許為空",
      "conditionRulesSet": "（已設置）",
      "conditionRulesUnSet": "（未設置）",
      "enableForbid": "開啟多實例後，禁止選擇返回我駁回規則中返回設定為[返回我]或者勾選[允許修改返回設定]時，不允許啟用多實例設定",
      "completionConditionRulesList": {
        "forward": "正向",
        "backward": "反向",
        "abort": "終止"
      }
    },
    "component": {
      "optins": {
        "wfOptions": "工作流選項",
        "specified": "指定子流程",
        "dynamic": "動態子流程",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "subProcessType": "子流程類型",
        "processType": "流程類型",
        "bizDef": "流程分類",
        "procDef": "流程定義",
        "clickCancel": "取消",
        "clickOk": "確定"
      },
      "voConfig": {
        "documentInfo": "單據信息",
        "viewModelSelection": "視圖模型選擇",
        "cancel": "取消",
        "clickOk": "確定",
        "selectOne": "確定",
        "documentTypeSelect": "單據類型選擇",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "viewModel": "視圖模型",
        "documenttype": "單據類型",
        "placeholder": "請選擇"
      },
      "variableSetting": {
        "constant": "常數",
        "expression": "表達式",
        "component": "構件",
        "ACTIVITY_STARTED": "活動開始",
        "ACTIVITY_COMPLETED": "活動結束",
        "varAssign": "變量賦值",
        "varNumber": "變量編號",
        "REQUIRED": "必填",
        "varName": "變量名稱",
        "valueType": "值類型",
        "executionTime": "執行時機",
        "valueText": "變量值",
        "processVariables": "流程變量",
        "notSelectedVar": "尚未選中變量！",
        "valueCannotEmpty": "變量值不允許為空！",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "add": "新增",
        "delete": "刪除",
        "serialNumber": "序號",
        "clickCancel": "取消",
        "clickOK": "確定",
        "inconsistentParameters": "當前構件方法參數不一致，請更新！",
        "methodNotExist": "當前構件已不存在此方法，請更新！",
        "parameterName": "參數名",
        "parameterValue": "參數值",
        "methodnotSelected": "尚未選擇構件方法",
        "metadataNotExist": "幫助元數據不存在，請聯繫系統管理員查看原因！",
        "errorObtainComponent": "獲取解析構件錯誤",
        "componentSelection": "構件選擇",
        "componentName": "構件名稱",
        "parameterList": "參數列表",
        "lineNumber": "序號"
      },
      "urgeHandleRule": {
        "urgentApproval": "催辦審批：",
        "pleaseApprove": "請您儘快審批",
        "soOn": "的",
        "urgeHandle": "催辦",
        "noSendingMethod": "尚未選擇發送方式！",
        "setMessageTemplate": "消息渠道啟用簡訊時需設置消息模板",
        "codeEmpty": "簡訊模板編號不允許為空",
        "noMessageSubject": "尚未配置消息主題！",
        "noMessageContent": "尚未選擇消息內容！",
        "earliestTimeNotEmpty": "最早允許催辦時間不允許為空",
        "minimumTimeNotEmpty": "最小允許催辦間隔不允許為空",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "enableUrgeHandle": "啟用催辦",
        "timeSetting": "時間設置",
        "earliestTime": "最早允許催辦時間（小時）",
        "minimumInterval": "最小允許催辦間隔（小時）",
        "sendingMethod": "發送方式",
        "messageSubject": "消息主題",
        "supportEditing": "支持編輯",
        "messageContent": "消息內容",
        "displayReminder": "顯示催辦人",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "titleExpression": {
        "zh-CHS": "中文简体",
        "zh-CHT": "中文繁體",
        "en": "英文",
        "taskDescription": "任務描述",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "currentLanguage": "當前摘要語言:",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "timeLimitControl": {
        "timedOutOperation": "超時操作",
        "constant": "固定值",
        "scope": "時間範圍",
        "day": "天",
        "hour": "時",
        "minute": "分",
        "BeforeDuration": "到期之前",
        "OnDuration": "到期時",
        "AfterDuration": "到期之後",
        "SendMessageExpireOperation": "超時預警",
        "AutoHandleExpireOperation": "自動辦理",
        "curDay": "當天",
        "durationType": "期限類型",
        "required": "必填",
        "timeDuration": "時長",
        "timeUnit": "單位",
        "operationTypeName": "操作類型名稱",
        "sendType": "操作",
        "onlyBeInteger": "任務期限只能是整數！",
        "setOperation": "請設置超時操作！",
        "setType": "請設置自動辦理類型！",
        "setComments": "請設置自動辦理意見！",
        "selectedOperation": "尚未選中預警操作！",
        "notSupportAutomatic": "下一節點是由當前辦理人指派的話，當前節點不支持任務自動辦理",
        "warningMessage": "預警消息",
        "automaticProcessing": "自動辦理",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "timelinessControl": "任務處理時效控制",
        "isEnable": "是否啟用",
        "taskDeadline": "任務期限",
        "timelyOperation": "時效預警操作",
        "actionList": "操作列表",
        "add": "新增",
        "remove": "刪除",
        "clickCancel": "取消",
        "clickOK": "確定",
        "workItemParticipant": "當前節點辦理人",
        "procInstCreator": "流程發起人",
        "to-doMessageTimeOut": "您有一條待辦消息即將超時。",
        "messageTimeOut": "您有一條消息即將超時",
        "agree": "同意"
      },
      "sendMessageOperation": {
        "procInstCreator": "流程發起人",
        "workItemParticipant": "當前節點辦理人",
        "preActExecutors": "上一節點辦理人",
        "day": "天",
        "hour": "時",
        "minute": "分",
        "cycleTimeNotEmpty": "循環時間間隔不允許為空！",
        "sendMethodNotEmpty": "發送方式不允許為空！",
        "subjectNotEmpty": "消息主題不允許為空！",
        "contentNotEmpty": "消息內容不允許為空！",
        "recipientNotEmpty": "接收人不允許為空！",
        "messageTemplate": "消息渠道啟用短信時需設置消息模板",
        "smsTemplateNumberNotEmpty": "短信模板編號不允許為空",
        "cycleEnable": "啟用循環預警",
        "cycleTime": "循環時間間隔",
        "sendType": "發送方式",
        "subject": "消息主題",
        "message": "消息內容",
        "receiverVari": "接收人",
        "sysUsers": "系統用戶",
        "clickCancel": "取消",
        "clickOK": "確定",
        "opinionsNotEmpty": "自動辦理意見不允許為空！",
        "processingNotEmpty": "自動辦理不允許為空！",
        "automaticProcessSet": "自動辦理設置",
        "automaticProcessMethod": "自動辦理方式",
        "automaticOpinionHandle": "自動辦理意見"
      },
      "smsMessageTemplate": {
        "smsTemplateContent": "協力廠商簡訊服務商裏定義的範本原文，例如：阿裡雲您的管控大數據平臺帳號已開通，用戶名為：${username}，初始密碼為：${code}，請及時登入系統",
        "code": "變量",
        "value": "值",
        "noRowsSelected": "尚未選中行",
        "smsMessageTemplate": "短信服務模板",
        "tips1": "消息模板是指已經在第三方短信服務商定義模板後，需要在GS Cloud裡將短信服務商的模板變量和GS Cloud變量關聯",
        "tips2": "第三方短信服務商裡定義的模板編號，例如: 阿里雲 SMS_220626324",
        "tips3": "將第三方短信服務商模板裡的變量和GSCloud裡的變量配置關聯",
        "smsTemplateNumber": "短信模板編號",
        "smsVariableBinding": "短信變量綁定",
        "addSmsVariable": "新增",
        "deleteSmsVariable": "刪除"
      },
      "signRule": {
        "countersignRules": "會簽規則",
        "byNumber": "按數量",
        "byProportion": "按比例(%)",
        "customConditions": "自定義條件",
        "value": "編號",
        "text": "名稱",
        "conclusionName": "結論名稱",
        "conclusionValue": "結論值",
        "calculateType": "計算方式",
        "conditionValue": "條件值",
        "waitAllVotes": "等待全員辦結",
        "yes": "是",
        "no": "否",
        "notEmpty": "完成策略為會簽時，會簽規則不允許為空，請了解！",
        "conditionNotEmpty": "計算方式設置為自定義條件時，自定義條件不能為空！",
        "pleaseSelect": "請首先選中一條審批項！",
        "maxConditionValue": "條件值最大值是100",
        "minConditionValue": "條件值最小值是0",
        "noConditional": "結論執行方式為全票或一票時不需要條件值",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "ruleList": "規則列表",
        "approvalOptions": "審批選項",
        "clickCancel": "取消",
        "deleteRow": "重置",
        "clickOK": "確定",
      },
      "saveAsEdit": {
        "public": "公有",
        "private": "私有",
        "code": "編號",
        "name": "名稱",
        "nameNotEmpty": "流程名稱不能為空",
        "organizationNotEmpty": "維護組織不能為空",
        "organization": "組織",
        "basicAttributes": "基礎屬性",
        "processName": "流程名稱",
        "processKeyValue": "流程Key值",
        "thisDocument": "本單據內",
        "otherDocument": "其他單據",
        "entryFormEmpty": "未選擇流程分類，請選擇流程分類或將另存位置切換為本單據內！",
        "entryForm": "流程分類",
        "savePos": "另存位置",
        "maintenanceOrg": "維護組織",
        "accessLevel": "訪問級別",
        "saveAsCancel": "取消",
        "saveAsOK": "確定"
      },
      "release": {
        "release": "流程發布",
        "update": "流程更新",
        "applicantName": "申請人名稱",
        "applicantDepartment": "申請人部門",
        "procName": "流程名稱",
        "procVersion": "流程版本",
        "releaseType": "發布類型",
        "textDetail": "說明",
        "saveAsCancel": "取消",
        "saveAsOK": "確定"
      },
      "processVariables": {
        "string": "字符",
        "integer": "整型",
        "decimal": "小數",
        "boolean": "布爾",
        "constant": "常量",
        "expression": "表達式",
        "component": "構件",
        "name": "變量編號",
        "required": "必填",
        "documentation": "變量名稱",
        "basicType": "變量類型",
        "description": "描述",
        "tag": "初始值類型",
        "valueText": "初始值",
        "processVariables": "流程變量",
        "notSelected": "尚未選中流程變量！",
        "variableNumberEmpty": "變量編號不允許為空！",
        "variableNameEmpty": "變量名稱不允許為空！",
        "variableNumberNotStandard": "變量編號只能包含字母、數字和下劃線，且不能以數字開頭！",
        "tagNotEmpty": "初始值類型不允許為空！",
        "codeDuplicates": "流程變量編號不允許重複！",
        "alreadyExists": "新增的變量已存在！",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "add": "新增",
        "delete": "刪除",
        "number": "序號",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "participant": {
        "user": "用戶",
        "variable": "變量參與者",
        "position": "崗位",
        "role": "角色",
        "component": "構件參與者",
        "reportingLine": "匯報關係",
        "matrix": "矩陣",
        "activityExecutor": "歷史活動辦理人",
        "organization": "單位/部門",
        "all": "所有",
        "assign": "指派",
        "claim": "領用",
        "currentUser": "當前辦理人",
        "procInstCreator": "流程發起人",
        "participantSet": "參與者設置",
        "order": "序號",
        "type": "類型",
        "performerName": "名稱",
        "description": "描述",
        "condition": "啟用條件",
        "dataMovement1": "是否將默認辦理人數據移動到到備選辦理人？",
        "dataMovement2": "是否將備選辦理人數據移動到默認辦理人？",
        "participantSelection": "參與者選擇",
        "selectProcessVariables": "尚未選擇流程變量！",
        "selectVariableValueType": "尚未選擇變量值類型！",
        "selectRelation": "尚未選擇關係！",
        "selectPosition": "尚未選擇崗位！",
        "selectOrgType": "尚未選擇組織類型！",
        "orgFill": "尚未填寫組織！",
        "refOrgIdNotNull": "參照類型為組織時，參照組織欄位不能為空",
        "refUserIdNotNull": "參照類型為系統用戶/員工時，參照人欄位不能為空",
        "repDefConfigured": "該匯報關係已經進行過配置",
        "atLeastOneCondition": "條件欄位至少要存在一個",
        "dataFieldAliasNotNull": "數據欄位不能為空",
        "matrixConfigured": "該矩陣已經進行過配置",
        "selectPerformer": "尚未選擇參與者",
        "definitionDeleted": "該條匯報關係數據的定義已刪除，該條數據將刪除",
        "matrixDeleted": "該條矩陣數據的定義已刪除，該條數據將刪除",
        "selectParticipantInfo": "請先選中一條參與者信息！",
        "noRowSelected": "尚未選中行！",
        "selectDefaultHandler": "請先選中一條默認辦理人",
        "selectpotentialtHandler": "請先選中一條備選辦理人",
        "org": "組織：",
        "positionType1": "崗位類型：通用崗位，組織：",
        "positionType2": "崗位類型：通用崗位",
        "positionType3": "崗位類型：組織崗位",
        "comp": "構件：",
        "parameters:": "，參數：{",
        "referencePerson:": "參照人：",
        "referenceOrganization:": "參照組織：",
        "code": "編號：",
        "condition1": "條件1：",
        "condition2": "條件2：",
        "condition3": "條件3：",
        "data": "數據：",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "allocationPolicy": "分配策略",
        "operator": "指派操作人",
        "multiSelect": "允許多選",
        "necessary": "只有一個待選用戶時，仍需手工選擇",
        "notifyRecipient": "知會接收人",
        "defaultHandler": "默認辦理人",
        "new": "新增",
        "editPerformer": "編輯",
        "removePerformer": "移除",
        "clearPerformer": "清空",
        "moveUp": "上移",
        "moveDown": "下移",
        "alternativeHandler": "備選辦理人",
        "isAllScope": "指定參與人時不限範圍，從全員用戶中選擇",
        "clickCancel": "取消",
        "clickOK": "確定",
        "alternativeScope": "備選範圍",
        "orgId": "組織ID",
        "includeChildren": "包含下級",
        "conditon": "啟用條件",
        "currentUnit": "本組織",
        "currentDepartment": "本部門",
        "variableOrganization": "變量組織"
        // "assignOrganization": "指定組織"
      },
      "activityExecutor": {
        "name": "名稱",
        "eventHandler": ">活動辦理人",
        "nodeName": "節點名稱",
        "enablingConditions": "啟用條件",
        "activityList": "活動列表",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "componentPerformer": {
        "componentMethod": "當前構件方法參數不一致，請更新！",
        "methodNotExist": "當前構件已不存在此方法，請更新！",
        "code": "編號",
        "name": "名稱",
        "description": "描述",
        "valueText": "參數值",
        "help": "幫助",
        "errorObtaining": "獲取解析構件出錯",
        "componentSelection": "構件選擇",
        "metadataNotExist": "幫助元數據不存在！",
        "serverSideNotFound": "服務器端未找到幫助元數據，請檢查元數據是否已經部署到環境中",
        "componentName": "構件名稱",
        "componentSelect": "構件選擇",
        "parameterList": "參數列表"
      },
      "matrixPerformer": {
        "code": "編號",
        "name": "名稱",
        "help": "幫助",
        "multivalue": "多值",
        "enumSelection": "枚舉選擇",
        "refMatrixTable": "引用矩陣表",
        "matrixTable": "矩陣表",
        "curDataFieldValue": "結果列",
        "conditionFields": "條件字段",
        "condition": "啟用條件",
        "key": "鍵",
        "value": "值",
        "notSelectEnum": "尚未選中枚舉值",
        "cancel": "取消",
        "onConfirm": "確定",
        "lineNumber": "序號"
      },
      "performerOptions": {
        "leave": "向下流轉",
        "throwException": "異常提示",
        "sys": "用戶ID",
        "administrative_staff": "員工ID",
        "procInstCreator": "流程發起人",
        "preActExecutors": "上一節點辦理人",
        "allPassExecutors": "所有已辦理人員",
        "performerOptions": "參與者選項",
        "exclusionNotAllowed": "所有已辦理人員已設置自動審批，上個節點已辦理人員默認不允許排除！",
        "approvalNotAllowed": "【分配策略】為【領用】時，不允許設置自動審批，請了解！",
        "approvalNotAllowedAsSet": "所有已辦理人員已設置不允許審批，所以上個節點已辦理人員默認不允許自動審批！",
        "allocationStrategyIsCollect": "【分配策略】為【領用】時，不允許設置自動審批，請了解！",
        "set": "（已設置）",
        "advancedOptions": "參與者高級選項",
        "historicFirst": "再次進入節點時，辦理人是節點的已辦人員",
        "noPerformerStrategy": "辦理人為空策略：",
        "excludeProcInstCreator": "排除辦理人選項",
        "defaultNotParticipate": "流程發起人默認不參與審批",
        "excludePreActExecutors": "上個節點已辦理人員默認不參與審批",
        "excludeAllPassExecutors": "所有已辦理人員默認不參與審批",
        "excludeExprPerformer": "流程變量：",
        "variableOrgTypes": "變量值類型：",
        "automaticApprovalOptions": "自動審批選項",
        "autoProcInstCreator": "流程發起人默認自動審批通過",
        "autoPreActExecutors": "上一節點辦理人員默認自動審批通過",
        "autoAllPassExecutors": "所有已辦理人員默認自動審批通過",
        "cancel": "取消",
        "clickOK": "確定"
      },
      "positionPerformer": {
        "orgPosition": "組織岗",
        "generalPosition": "通用岗",
        "sysPositions": "系統岗位",
        "positionType": "岗位類型",
        "role": "角色",
        "position": "岗位",
        "sysType": "組織類型",
        "placeholder": "請選擇",
        "orgId": "組織ID",
        "condition": "啟用條件",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "reportingLine": {
        "higherSuperior": "間接上級",
        "directSuperior": "直接上級",
        "code": "編號",
        "name": "名稱",
        "dept": "組織",
        "sysUser": "系統用戶",
        "employee": "員工",
        "businessFields": "業務字段",
        "defName": "匯報定義",
        "dimension": "匯報級別",
        "curReportingRefer": "參照類型",
        "usersName": "參照人",
        "refOrgId": "參照組織",
        "condition": "啟用條件",
        "definitionOfReport": "匯報關係定義"
      },
      "userPerformer": {
        "regularUser": "固定使用者",
        "variablePart": "變數參與者",
        "sys": "系統使用者",
        "administrative_organization": "員工",
        "cantUseContext": "行政人員類型不能使用此上下文變數",
        "user": "使用者",
        "variable": "變數",
        "condition": "啟用條件"
      },
      "variablePerformer": {
        "sys": "使用者ID",
        "administrative_staff": "員工ID",
        "oneself": "本人",
        "administrative_organization": "部門ID",
        "cantUseContext": "行政人員類型不能使用此上下文變數",
        "processVariables": "流程變數",
        "variableOrgTypes": "變數值類型",
        "relationShipType": "關係",
        "condition": "啟用條件",
      },
      "orgPotentialOwner": {
        "optionSettings": "選項設置",
        "global": "全體成員",
        "currentUnit": "本單位",
        "currentDepartment": "本部門",
        "addSignBehind": "加簽",
        "addSignFront": "徵詢",
        "transfer": "移交",
        "notify": "知會",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "option": "選項",
        "enable": "是否啟用",
        "range": "範圍",
        "OrgId": "組織ID",
        "variableOrganization": "變數組織",
        "includeChildren": "包含下級",
        "clickCancel": "取消",
        "clickOK": "確定",
        "limit": "限定人員範圍",
        "turnOffPrompt": "請關閉限定人員範圍選項"
      },
      "note": {
        "placeholder": "請輸入流程變更記錄",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "MessageNotice": {
        "notify": "消息通知",
        "subject": "消息主題",
        "content": "消息內容",
        "sendTime": "發送時機",
        "sendType": "發送方式",
        "receiverText": "消息接收人",
        "procInstCreator": "流程發起人，",
        "workItemParticipant": "任務接收人，",
        "messageSet": "消息設置",
        "selectedRow": "尚未選中消息通知！",
        "noCopy": "沒有待複製的消息通知屬性！",
        "batchCopy": "批量複製",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "add": "新增",
        "edit": "編輯",
        "delete": "刪除",
        "lineNumber": "序號",
        "clickCancel": "取消",
        "clickOK": "確定",
        "messContent": `{"expr":"\'您有一條消息通知。\'","sexpr":""}`,
        "procComplete": "流程完成",
        "procAborted": "流程終止",
        "procRollBack": "流程驳回",
        "workCreated": "任務創建",
        "workAborted": "任務終止",
        "actComplete": "活動完成",
        "actAborted": "活動終止",
        "email": "郵件",
        "sms": "短信",
        "cloudplus": "雲",
        "processParticipant": "流程參與人",
        "variableParticipant": "變數參與者",
        "userParticipant": "指定使用者",
        "positionParticipant": "崗位",
        "activityExecutorParticipant": "歷史辦理人",
        "sys": "系統使用者",
        "administrative_organization": "員工",
        "name": "名稱",
        "noTargetNode": "尚未選中節點！",
        "noMessageNotifyAttribute!": "沒有消息通知屬性！"
      },
      "messageNoticeEdit": {
        "procInstCreator": "流程發起人",
        "activityExecutorParticipant": "歷史辦理人",
        "workItemParticipant": "任務辦理人",
        "sys": "系統使用者",
        "administrative_organization": "員工",
        "processParticipant": "流程參與人",
        "workItemReceiveParticipant": "任務接收人",
        "variableParticipant": "變數參與者",
        "userParticipant": "指定使用者",
        "positionParticipant": "崗位",
        "sendType": "發送方式不允許為空",
        "smsMessageTemplate": "消息渠道啟用短信時需設置消息模板",
        "smsMessageTemplateCode": "短信模板編號不允許為空",
        "sendTime": "發送時機不允許為空",
        "subject": "消息主題不允許為空",
        "content": "消息內容不允許為空",
        "receivers": "接收人不允許為空！",
        "processParticipantNotNull": "流程參與人不允許為空",
        "activityDefIdNotNull": "流程參與人為歷史辦理人時，辦理節點不允許為空",
        "variableParticipantNotNull": "變數參與者不允許為空",
        "orgType": "變數參與者組織類型不允許為空",
        "userIds": "指定使用者不允許為空",
        "positionId": "崗位不允許為空",
        "activityList": "活動列表",
        "position": "崗位",
        "optionalNodes": "可選節點",
        "targetNodeList": "目標節點列表",
        "placeholder": "請選擇目標節點",
        "optionalAttribute": "可選屬性",
        "lineNumber": "序號",
        "clickCancel": "取消",
        "clickOK": "確定",
        "messSendType": "消息渠道",
        "messSubject": "消息主題",
        "enable": "啟用表達式",
        "messContent": "消息內容",
        "recipient": "接收人",
        "addReceiver": "添加",
        "organization": "組織：",
        "posi": "崗位："
      },
      "jumpScope": {
        "targetNodeOptions": "目標節點選項",
        "name": "名稱",
        "outConnectNode": "流程圖連線節點",
        "global": "流程內所有節點",
        "afterNodes": "所有後繼節點",
        "specifiedSet": "流程圖連線節點+附加節點",
        "firstNode": "條件為true的連線節點，當有多條時默認選中首條",
        "nullNode": "默認為空，每次都手動選擇",
        "specifyNode": "指定默認節點",
        "noSetTargetNode": "尚未設置目標節點選項，請了解！",
        "noSetSpecifyNode": "尚未指定默認節點，請了解！",
        "selectedRow": "請首先選中一條選項！",
        "optionalNodes": "可選節點",
        "listOfAdditional": "附加節點列表",
        "pleaseSelect1": "請選擇附加節點",
        "defaultNode": "默認節點",
        "pleaseSelect2": "請選擇默認節點",
        "defaultNodeList": "默認節點列表",
        "clickCancel": "取消",
        "clickOK": "確定",
        "set": "（已設置）"
      },
      "imageSet": {
        "imageSet": "影像設置",
        "onlyView": "僅可查看",
        "edit": "編輯",
        "reScanStart": "發起重掃",
        "reScanComplete": "重掃完成",
        "mutualExclusion": "【僅可查看】選項與其他選項互斥，請了解！",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "imageOperation": "影像操作權限",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "extendProperty": {
        "extendProperty": "擴展屬性",
        "true": "是",
        "false": "否",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "illustrate": "說明",
        "placeholder": "請選擇",
        "cancel": "取消",
        "clickOK": "確定"
      },
      "expressionEditor": {
        "expressionEditor": "條件編輯",
        "notSet": "（未設置）",
        "clickCancel": "取消",
        "changeType": "切換類型",
        "clickOK": "確定"
      },
      "executeForms": {
        "executeForms": "表單定義",
        "parameters": "參數【",
        "typeAsvariable": "】類型為變量，但在流程變量裡不存在",
        "parameterSettings": "參數設置",
        "formDefinitionList": "表單定義列表",
        "notSet": "（未設置）",
        "default": "流程默認表單",
        "processEmbeddedForm": "流程嵌表單",
        "formEmbedProcess": "表單嵌流程",
        "clickCancel": "取消",
        "clickOK": "確定",
        "noForm": "暫無表單格式",
        "form": "選擇表單",
        "placeholder": "請選擇",
        "parametersSet": "參數",
        "key": "變量編號",
        "name": "變量名稱",
        "lineNumber": "序號",
        "code": "編號",
        "paramName": "名稱",
        "tag": "類型",
        "value": "參數值",
        "variable": "變量",
        "constant": "常量",
        "expression": "表達式",
        "method": "方法標識",
        "methodName": "方法名稱",
        "description": "描述",
        "workFlowAction": "流轉方向",
        "formOperations": "表單操作",
        "executionTime": "執行時機",
        "sortOrder": "執行順序",
        "methodParameters": "參數",
        "selectFormActionConfig": "尚未選中表單操作配置！",
        "selectFormAction": "尚未選中表單操作！",
        "editParam": "設置",
        "formEvents": "表單事件",
        "buttonName": "按鈕名稱",
        "enable": "是否可用",
        "disabled": "是否禁用",
        "hidden": "是否隱藏",
        "fieldName": "字段名稱",
        "editable": "是否可寫",
        "readonly": "是否只讀",
        "required": "是否必填",
        "saveFail": "保存配置失敗，請聯繫管理員查看原因！",
        "checkedRows": "尚未選擇按鈕集合",
        "checkeds": "尚未選擇字段集合",
        "enableBtn": "可用",
        "disabledBtn": "禁用",
        "hiddenBtn": "隱藏",
        "btnBatchReset": "重置",
        "editableBtn": "可寫",
        "readonlyBtn": "只讀",
        "requiredBtn": "必填",
        "add": "新增",
        "delete": "刪除",
        "other": "其他",
        "formBtn": "表單按鈕",
        "formfield": "表單字段",
        "apptag": "單據類型",
        "functionMenu": "功能菜單",
        "formFormat": "表單格式",
        "docFormatNumber": "單據格式編號",
        "docFormatName": "單據格式名稱",
        "selectedRow": "尚未選擇表單定義！",
        "set": "（已設置）",
        "operationDelete": "該操作不允許删除",
        "operationAdd": "該操作無法新增",
        "alreadySelect": "該表單定義已被選擇，請選擇其他表單",
        "canAddSameOperation": "表單操作不允許重複"
      },
      "eventDefinition": {
        "eventDefinition": "信號定義",
        "pass": "正向",
        "back": "反向",
        "abort": "終止",
        "signalRef": "信號編號",
        "name": "信號名稱",
        "triggerAction": "流轉方向",
        "selectedRow": "尚未選中一條觸發事件！",
        "dataLength": "至少需要一個信號定義，請了解！",
        "codeNotNull": "信號編號不允許為空！",
        "nameNotNull": "信號名稱不允許為空！",
        "codeNotNumber": "信號編號不允許為純數字！",
        "codeRepeat": "信號編號不允許重複！",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "add": "新增",
        "delete": "刪除",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "entryFormEditor": {
        "flowForm": "流程分類",
        "code": "編號",
        "name": "名稱",
        "base": "類型",
        "foundation": "基礎",
        "extend": "擴展",
        "selectedRow": "尚未選擇流程分類",
        "absent": "流程分類已經不存在",
        "lineNumber": "序號",
        "clickCancel": "取消",
        "clickOK": "重新綁定"
      },
      "editComponentParameter": {
        "code": "編號",
        "name": "名稱",
        "required": "必填",
        "yes": "是",
        "no": "否",
        "value": "參數值",
        "openComponentFail": "獲取解析構件出錯",
        "componentSelection": "構件選擇",
        "curComponent": "請選擇流程構件",
        "executionTime": "請選擇執行時機",
        "para": "參數",
        "paraRequired": "】必填",
        "execuTime": "執行時機",
        "parameterList": "參數列表",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "customizeAction": {
        "customizeAction": "自定義動作",
        "app": "移動",
        "web": "web",
        "all": "web,移動",
        "name": "名稱",
        "code": "編號",
        "terminalType": "適用終端",
        "isAll": "是否默認",
        "yes": "是",
        "no": "否",
        "paramName": "編號",
        "valueText": "名稱",
        "value": "參數值",
        "addActions": "自定義動作選擇",
        "actionExisted": "新增的自定義動作已經存在！",
        "selectedRow": "請首先選中一條選項！",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "add": "新增",
        "delete": "刪除",
        "parameterList": "參數列表",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "checkCondition": {
        "zhChs": "簡體中文",
        "zhCht": "繁體中文",
        "en": "英文",
        "checkCondition": "活動校驗規則",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "nodeEntry": "節點進入",
        "activityBeforeStarted": "節點進入條件",
        "enterErrorTips": "進入條件不匹配提示語",
        "activityBeforeCompleted": "節點離開",
        "activityBeforeCompletedValue": "節點離開條件",
        "leaveErrorTips": "離開條件不匹配提示語",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "batchSet": {
        "targetNode": "目標節點",
        "addSignFront": "徵詢",
        "addSignBehind": "加簽",
        "transfer": "移交",
        "notify": "知會",
        "backWardRule": "駁回規則",
        "participantOptions": "參與者選項",
        "name": "名稱"
      },
      "subProcess": {
        "subProcessSet": "子流程設置",
        "specified": "指定子流程",
        "dynamic": "動態子流程",
        "inheritParent": "與父流程相同",
        "autoCreation": "自动生成下游單據",
        "variablesExpression": "變量表達式",
        "rteNull": "請選中一條生單流程",
        "orderProcess": "生單流程",
        "clickOk": "確定",
        "clickCancel": "取消",
        "inheritBizDataId": "當子流程與父流程單據不一致時，請設置子流程單據內碼！",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "radioGroupProcessType": "子流程類型",
        "flowForm": "流程分類",
        "processDef": "流程定義",
        "radioGroupBillSource": "單據來源",
        "autoCreationProcess": "生單流程",
        "bizDataId": "單據內碼",
        "setOption": "設置選項",
        "SameParentProcess": "與父流程同一張業務單據",
        "setBizDataId": "設置單據內碼",
        "subProcessOpt": "子流程選項"
      },
      "backwardRule": {
        "reEdit": "駁回活動節點已不存在，請重新編輯",
        "backwardRule": "駁回規則",
        "initialActityId": "開始節點",
        "precursorActivityId": "前置節點",
        "empty": "空",
        "name": "名稱",
        "id": "標識",
        "sequence": "順序流轉",
        "backToMe": "返回我",
        "backToCurrentNode": "返回本節點",
        "popover": "1.順序流轉:按照流轉線順序進行流轉; 2.返回我:完成策略為搶佔：只給駁回人創建任務,完成策略為會簽：駁回人與未審批人收到新任務，已審批人員自動審批通過; 3.返回本節點:實際效果受“再次進入節點時，辦理人是否是節點已辦人員影響”選項的影響",
        "selectAbleClick": "會簽策略下，不允許動態選擇駁回目標節點!",
        "dictPicked": "“駁回至空”選項請搭配“允許動態選擇駁回目標節點”使用",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "rejectedTo:": "駁回至：",
        "backScope": "駁回範圍",
        "defaultPrompt": "默認選取全部歷史駁回節點",
        "title": "活動列表",
        "dynamicSelection": "允許動態選擇駁回目標節點",
        "resubmitEffectOptions": "返回設置",
        "popover1": "1.順序流轉:按照流轉線順序進行流轉; ",
        "popover2": "2.返回我:完成策略為搶佔：只給駁回人創建任務,完成策略為會簽：駁回人與未審批人收到新任務，已審批人員自動審批通過;",
        "popover3": "3.返回本節點:實際效果受“再次進入節點時，辦理人是否是節點已辦人員影響”選項的影響",
        "allowModification": "允許修改返回設置",
        "dynamicBackWardRuleAbleClick": "開啟多實例後，禁止勾選允許修改返回設定",
        "backToMeForbid": "開啟多實例後，禁止選擇返回我",
        "clickCancel": "取消",
        "clickOk": "確定"
      },
      "assignStrategy": {
        "all": "所有",
        "assign": "指派",
        "claim": "領用",
        "currentUser": "當前辦理人",
        "procInstCreator": "流程發起人",
        "assignStrategy": "分配策略",
        "option": "選項",
        "assignmentRules": "指派規則",
        "operator": "指派操作人",
        "multiSelect": "允許選擇多個待選用戶",
        "necessary": "只有一個待選用戶時，仍需手工選擇",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "assignScope": {
        "assignScopeList": "指派節點列表",
        "required": "必填",
        "yes": "是",
        "no": "否",
        "condition": "條件",
        "add": "增加",
        "delete": "刪除",
        "name": "名稱",
        "deleteRow": "請首先選中壹條選項！",
        "curActivity": "尚未選中行",
        "duplicateNodeNoAdd": "已選擇節點不會重複新增",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "nodeList": "節點列表",
        "moveUp": "上移",
        "moveDown": "下移",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "assignPerformer": {
        "currentUser": "當前辦理人",
        "procInstCreator": "流程發起人",
        "global": "全員",
        "currentUnit": "本單位",
        "currentDepartment": "本部門",
        "assignPerformer": "指派規則",
        "set": "（已設置）",
        "operator": "指派操作人",
        "multiSelect": "允許選擇多個待選用戶",
        "necessary": "只有一個待選用戶時，仍需手工選擇",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "approvelItems": {
        "approvalOptions": "審批選項",
        "forward": "正向",
        "backward": "反向",
        "abort": "終止",
        "value": "編號",
        "text": "名稱",
        "workFlowAction": "流轉方向",
        "isDefault": "默認",
        "no": "否",
        "yes": "是",
        "commentNecessary": "意見必填",
        "attachmentNecessary": "附件上傳",
        "certification": "數字簽名",
        "signatureNecessary": "手寫簽名必填",
        "defaultComment": "默認意見",
        "zh-CHS": "中文簡體",
        "zh-CHT": "中文繁體",
        "en": "英文",
        "workFlowActionNotNull": "審批項流轉方向不允許為空，請修改！",
        "deleteRow": "請首先選中壹條選項！",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "add": "新增",
        "delete": "刪除",
        "clickCancel": "取消",
        "clickOK": "確定",
        "approvalAction": "審批動作",
        "lineNumber": "序號"
      },
      "approvalPivot": {
        "remind": "文字提示",
        "type": "類型",
        "condition": "條件",
        "title": "顯示名稱",
        "description": "詳細說明",
        "approvalPivot": "審批要點",
        "selectedRow": "尚未選中審批要點！",
        "configTitle": "尚未填寫顯示標題！",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "enable": "是否啟用",
        "expand": "是否展開",
        "showTitle": "顯示標題",
        "list": "列表",
        "add": "新增",
        "delete": "刪除",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "anonymousSet": {
        "anonymousOpt": "匿名選項",
        "approver": "審批人",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "anonymousSet": "匿名設置",
        "isAnonymity": "是否啟用",
        "anonymous": "匿名代稱",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "activityList": {
        "name": "名稱",
        "checkeds": "尚未選擇活動節點",
        "lineNumber": "序號",
        "clickCancel": "取消",
        "clickOK": "確定"
      },
      "activityComponent": {
        "component": "構件",
        "method": "構件方法",
        "inconsistentParameters": "參數不壹致，請檢查",
        "longerExists": "構件已不存在此構件方法",
        "absent": "取消",
        "pleaseCheck": "，請檢查",
        "edit": "編輯",
        "deleteRow": "刪除",
        "executionTime": "執行時機",
        "cmpName": "構件名稱",
        "metadataId": "構件ID",
        "methodCode": "構件方法",
        "isForCompensation": "補償操作",
        "yes": "是",
        "no": "否",
        "operate": "操作",
        "code": "編號",
        "name": "名稱",
        "value": "參數值",
        "editComponent": "編輯構件",
        "confirmDelete": "確認是否刪除構件？",
        "curComponent": "尚未選中構件！",
        "newComponent": "新建構件",
        "selectComponent": "Select Component",
        "sameCmp": "存在相同的流程構件",
        "cmpMethod": "構件方法：",
        "executionTimeNotNull": "構件執行時機不允許為空！",
        "param": "的參數",
        "required": "必填",
        "set": "（已設置）",
        "notSet": "（未設置）",
        "PROCESSINSTANCE_STARTED": "流程啟動",
        "PROCESSINSTANCE_SUSPENDED": "流程挂起",
        "PROCESSINSTANCE_RESUMED": "流程恢復",
        "PROCESSINSTANCE_COMPLETED": "流程完成",
        "PROCESSINSTANCE_ABORTED": "流程終止",
        "PROCESSINSTANCE_CANCELED": "流程取消",
        "PROCESSINSTANCE_REACTIVATED": "流程復活",
        "PROCESSINSTANCE_ROLLBACK": "流程驳回",
        "PROCESSINSTANCE_RESUBMIT": "重新提交",
        "ACTIVITY_AND_PARTICIPANT_UPDATED": "環節辦理人變更",
        "PROCESSINSTANCE_ABORTED_BY_ADMIN": "管理員終止",
        "PROCESSINSTANCE_BEFORE_START": "流程啟動前",
        "WORKITEM_BEFORE_COMPLETE": "任務完成前",
        "WORKITEM_AFTER_COMPLETE": "任務完成後",
        "LOADDATA": "獲取數據",
        "ACTIVITY_STARTED": "活動啟動",
        "ACTIVITY_COMPLETED": "活動完成",
        "ACTIVITY_ABORTED": "活動終止",
        "WORKITEM_CREATED": "工作項創建",
        "WORKITEM_COMPLETED": "工作項完成",
        "WORKITEM_SUSPENDED": "工作項挂起",
        "WORKITEM_RESUMED": "工作項恢復",
        "WORKITEM_ABORTED": "工作項終止",
        "WORKITEM_RETRIEVED": "工作項取回",
        "WORKITEM_CLAIMED": "工作項領用",
        "WORKITEM_UNCLAIMED": "工作項反領用",
        "ACTIVITY_ASSIGNMENT": "任務分配前",
        "deleteNotAllowed": "取數構件不允許刪除，請了解！",
        "tips": "提示：",
        "prefabricated": "已經預製外部流程構件，此處只保留取數構件",
        "add": "新增",
        "moveUp": "上移",
        "moveDown": "下移",
        "clickCancel": "取消",
        "clickOK": "確定"
      }
    }
  }
}
